<template>
  <div class="app-main-inner" style="width: fit-content">
    <div class="section">
      <el-form
        v-if="isFba"
        :disabled="readonly"
        class="section"
        style="flex-direction: row;"
      >
        <span style="display: flex;align-items: center;width: 64px">
          {{ $t('FbaJob.ValueAddedServices') }}
        </span>
        <el-checkbox-group v-model="selectedLocalAddedService" @change="addedServiceChangeHandler">
          <el-checkbox
            v-for="item in localAddedService"
            :key="item.code"
            :label="item.code"
            style="margin-left: 8px;margin-right: 8px"
            @change="val => singleAddedServiceChangeHandler(val, item)"
          >
            {{ item.chineseName }}
          </el-checkbox>
        </el-checkbox-group>
        <el-checkbox v-if="isBookingNew" v-model="form.destinationPortService" style="margin-left: 8px;margin-right: 8px" no="destinationPortService">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
        <el-button
          v-if="viewSource === 'bookingWorkspace'"
          v-permission="['button_insurance_toInsure']"
          :disabled="isEdit"
          no="toInsure"
          type="primary"
          style="margin-left: 20px;"
          @click="pm.toInsure()"
        >{{ $t('SeaExport.Insure') }}</el-button>
      </el-form>
      <el-form v-if="!isFba">
        <el-checkbox v-model="form.booking" :disabled="readonly" no="booking">{{ $t('SeaExport.Booking') }}</el-checkbox>
        <el-checkbox
          v-model="form.customs"
          :disabled="readonly"
          no="customs"
          style="margin-left: -20px;"
          @change="val=>{form.customsBroker=val?form.customsBroker:0;form.customsDeclarationType=val?form.customsDeclarationType:-1}"
        >{{ $t('SeaExport.CustomsDeclaration') }}</el-checkbox>
        <el-checkbox v-model="form.insure" :disabled="readonly" no="isInsure" style="margin-left: -20px;">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
        <el-checkbox
          v-model="form.comercialInspectation"
          :disabled="readonly"
          no="comercialInspectation"
          style="margin-left: -20px;"
        >{{ $t('SeaExport.CommodityInspection') }}</el-checkbox>
        <el-checkbox v-model="form.heating" :disabled="readonly" no="heating" style="margin-left: -20px;">{{ $t('SeaExport.Fumigation') }}</el-checkbox>
        <el-checkbox v-model="form.itmService" :disabled="readonly" no="itmService" style="margin-left: -20px;">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
        <el-checkbox
          v-model="form.headwayTail"
          :disabled="readonly"
          no="headwayTail"
          style="margin-left: -20px;"
        >{{ $t('RailwayExport.isHeadwayTail') }}</el-checkbox>
        <el-checkbox v-if="isBookingNew && isFba" v-model="form.destinationPortService" no="destinationPortService" style="margin-left: -20px;">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
        <el-button
          v-if="viewSource==='bookingWorkspace'"
          v-permission="['button_insurance_toInsure']"
          :disabled="isEdit"
          no="toInsure"
          type="primary"
          style="margin-left: 20px;"
          @click="pm.toInsure()"
        >{{ $t('SeaExport.Insure') }}</el-button>
        <span v-if="!isFba" style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_BusinessType') }}</span>
        <el-radio-group v-if="!isFba" v-model="form.lob" :disabled="readonly||Boolean(form.lclMasterUuid)" no="lob" style="margin-left: 10px;" @change="lobChangeHandler">
          <el-radio no="RE" label="RE">{{ $t('CargoMsg.Cargo_Export') }}</el-radio>
          <el-radio no="RI" label="RI" style="margin-left: -20px;">{{ $t('CargoMsg.Cargo_JobTypeImport') }}</el-radio>
        </el-radio-group>
      </el-form>
    </div>
    <div style="width: fit-content">
      <div style="display: flex">
        <div class="section form-column" style="width: 320px">
          <el-form :disabled="readonly" label-width="120px" label-position="right">
            <span class="title">{{ $t('SeaExport.ConsignInfo') }}</span>
            <el-form-item :label="$t('SeaExport.BusinessNo')">
              <el-input :value="form.jobNo" :disabled="true" no="jobNo" />
            </el-form-item>
            <template v-if="isZY">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                  filterable
                  no="allowSaleProduct"
                  clearable
                  :data-filter-function="p => {
                    if (!p.statusEnabled) {
                      return false
                    }
                    return isFba ? p.fbaRailway : p.railwayFreight
                  }"
                  :default-value="form.saleProductCode || ''"
                  @parentCallBack="p => {form.saleProductCode = p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                  no="fullOrInside"
                  clearable
                  :default-value="form.fullOrInside || ''"
                  @parentCallBack="p => {form.fullOrInside = p.value}"
                />
              </el-form-item>
            </template>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.ConsignationCompany') }}</span>
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="showWarningImageB"
                  :content="warningImageBTip"
                  placement="right-end"
                >
                  <i
                    class="el-icon-warning red"
                    style="cursor: pointer"
                  />
                </el-tooltip>
                <cargo-sales-company-select
                  v-if="!isFba"
                  ref="customerSelect"
                  no="customerId"
                  :method-params="{customer:true,active:true,companyLob:'railwayExport'}"
                  :check-credit="true"
                  :default-value="form.customerId||''"
                  :disabled="!customerEnabled"
                  :job="form"
                  @parentCallBack="p=>{customerIdChange2ContractHandler(p);clearPoNo()}"
                />
                <cargo-company-select
                  v-if="isFba"
                  ref="customerSelect"
                  no="customerId"
                  :method-params="{customer:true,companyLob:'railwayExport',active:true, fba:true}"
                  :check-credit="true"
                  :job="form"
                  :default-value="form.customerId||''"
                  :disabled="!customerEnabled"
                  style="flex: 1;"
                  :data-filter-function="fbaCustomerIdFilter"
                  @change="p=>{customerIdChange2ContractHandler(p);clearPoNo()}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerProperty')">
              <el-tooltip :content="customerTip" placement="bottom">
                <span
                  v-show="customerLevel.level!==''"
                  style="color:#FD9A14"
                >LV{{ customerLevel.level }}</span>
                <span style="color:#D3A73B">&nbsp;{{ customerLevel.customerName }}</span>
                <span v-show="contractStatusLabel" class="red">&nbsp;({{ contractStatusLabel }})</span>
                <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
                <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
                  <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
                </span>
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContactPerson')">
              <div style="display: flex">
                <el-select
                  v-model="form.customerContact"
                  no="customerContact"
                  filterable
                  :allow-create="true"
                  style="flex:1"
                >
                  <el-option
                    v-for="(item,index) in contactList"
                    :key="index"
                    :label="item.contactPerson"
                    :value="item.contactPerson"
                  />
                </el-select>&nbsp;
                <el-link
                  v-show="!isShowContactPersonDetail"
                  no="Detail"
                  :class="form.customerContact?'':'not-click'"
                  @click="showContactDialog"
                >{{ $t('SeaExport.Detail') }}</el-link>
              </div>
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.containerLoadType')">
              <el-select
                v-model="form.containerLoadType"
                :disabled="!lclslaveEnabled"
                no="containerLoadType"
                @change="val=>{pm.containerLoadTypeChange(val)}"
              >
                <el-option
                  v-for="(item,index) in containerLoadTypes"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoType')">
              <el-select v-model="form.cargoType" filterable @change="onCargoTypeChagne">
                <el-option
                  v-for="(item,index) in cargoType4JobSelect"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">
                {{ $t('RailwayExport.transportType') }}
              </span>
              <cargo-advance-select
                :disabled="!lclslaveEnabled"
                no="transportType"
                :select-type="selectTypeNames.basic_data_TransportationType"
                :method-params="{companyLob:'railwayExport',transportType:true,active:true}"
                filterable
                :default-value="form.transportType"
                :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
                :tag-value="'code'"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="p=>{form.transportType=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">
                {{ $t('RailwayExport.fullHalf') }}
              </span>
              <cargo-advance-select
                :disabled="!lclslaveEnabled"
                no="fullHalf"
                :select-type="selectTypeNames.local_cache_FullHalf"
                filterable
                :default-value="form.fullHalf"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="p=>{form.fullHalf=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">
                {{ $t('RailwayExport.transportLine') }}
              </span>
              <cargo-advance-select
                :disabled="!lclslaveEnabled"
                no="transportLine"
                :select-type="selectTypeNames.basic_data_RailwayLine"
                filterable
                :default-value="form.transportLine"
                :placeholder="$t('SeaExport.RequiredItem')"
                tag-name="name"
                @parentCallBack="p=>{form.transportLine=p.value;pm.refreshPlanner(p.value)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">
                {{ $t('RailwayExport.ETD2') }}
              </span>
              <div style="display: flex">
                <el-date-picker
                  no="etd"
                  class="departure-date-picker"
                  :value="form.etd"
                  :disabled="form.uuid&&form.lclMasterUuid?true:!etdEnabled || (provisionEtdLocked && form.lob === 'RE')"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="flex: 1; width:140px; margin-right: 5px"
                  @input="etdChange"
                />
                <span>{{ form.sailingDay|filterWeek }}</span>
              </div>
              <span v-if="provisionEtdLocked && form.lob === 'RE'" style="color: red; font-size: 12px;">(已计提校准不可修改)</span>
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.ETA2')">
              <span v-if="form.lob === 'RI'" slot="label" class="blue">
                {{ $t('RailwayExport.ETA2') }}
              </span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.eta"
                  :disabled="!lclslaveEnabled || (provisionEtdLocked && form.lob === 'RI')"
                  no="eta"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="flex: 1; width:140px; margin-right: 5px"
                  @input="etaChange"
                />
                <span>{{ form.etaSailingDay|filterWeek }}</span>
              </div>
              <span v-if="provisionEtdLocked && form.lob === 'RI'" style="color: red; font-size: 12px;">(已计提校准不可修改)</span>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('RailwayExport.ATD2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.atd"
                  :disabled="!lclslaveEnabled"
                  no="atd"
                  type="date"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="flex: 1; width:140px; margin-right: 5px"
                  @input="atdChange"
                />
                <span>{{ form.atdSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('RailwayExport.ATA2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.ata"
                  :disabled="!lclslaveEnabled"
                  no="ata"
                  type="date"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="flex: 1; width:140px; margin-right: 5px"
                  @input="ataChange"
                />
                <span>{{ form.ataSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationDate')">
              <el-date-picker
                v-model="form.customsDate"
                no="customsDate"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">
                {{ $t('RailwayExport.departureStation') }}
              </span>
              <div style="display: flex">
                <cargo-advance-select
                  :disabled="!lclslaveEnabled"
                  no="departureStation"
                  :select-type="selectTypeNames.basic_data_RailwayStation"
                  filterable
                  :default-value="form.departureStation"
                  :placeholder="$t('SeaExport.RequiredItem')"
                  @parentCallBack="departureStationChange"
                />
                <el-checkbox
                  v-model="form.transfer"
                  :disabled="!lclslaveEnabled"
                  no="transfer"
                  style="width:80px; padding-left: 5px;"
                >{{ $t('SeaExport.Transit') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item
              v-show="form.transfer"
            >
              <span slot="label" class="blue">
                {{ $t('RailwayExport.transferStation') }}
              </span>
              <cargo-advance-select
                :disabled="!lclslaveEnabled"
                no="transferStation"
                :select-type="selectTypeNames.basic_data_RailwayStation"
                filterable
                :default-value="form.transferStation"
                @parentCallBack="p=>{form.transferStation=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">
                {{ $t('RailwayExport.transitStation') }}
              </span>
              <cargo-advance-select
                :disabled="!lclslaveEnabled"
                no="transitStation"
                :select-type="selectTypeNames.basic_data_RailwayStation"
                filterable
                :default-value="form.transitStation"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="p=>{form.transitStation=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">
                {{ $t('RailwayExport.destinationStation') }}
              </span>
              <cargo-advance-select
                no="destinationStation"
                :select-type="selectTypeNames.basic_data_RailwayStation"
                filterable
                :default-value="form.destinationStation"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="destinationStationChange"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.destinationCountry')">
              <cargo-advance-select
                no="destinationCountry"
                :select-type="selectTypeNames.basic_data_Country"
                filterable
                :default-value="form.destinationCountry"
                @parentCallBack="p=>{form.destinationCountry=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SolicitationType')">
              <el-select
                v-model="form.cargoSource"
                :disabled="!cargoSourceEnabled"
                no="cargoSource"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
                @change="form.designationAgent=0;pm.cargoSourceChange({fieldName:'cargoSource'})"
              >
                <el-option
                  v-for="(item,index) in CARGO_SOURCES"
                  :key="index"
                  :label="item.chineseName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomJobType')">
              <cargo-advance-select
                v-if="form.lob==='RE'"
                key="1"
                ref="customJobType"
                no="customJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :method-params="{type:form.lob}"
                :tag-name="isZh?'name':'englishName'"
                :static-options="customJobTypeList"
                :default-value="form.customJobType"
                @parentCallBack="p=>{form.customJobType=p.value;onCustomJobTypeChange();contractRuleFieldChange(form.customerId, form.designationAgent)}"
              />
              <cargo-advance-select
                v-else-if="form.lob==='RI'"
                key="2"
                ref="customJobType"
                no="customJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :tag-name="isZh?'name':'englishName'"
                :static-options="customJobTypeList"
                :method-params="{type:form.lob}"
                :default-value="form.customJobType"
                @parentCallBack="p=>{form.customJobType=p.value;onCustomJobTypeChange();contractRuleFieldChange(form.customerId, form.designationAgent)}"
              />
            </el-form-item>
            <el-form-item v-if="form.customJobType && secondaryCustomJobTypeList.length > 0" :label="$t('CargoMsg.Cargo_Grade')">
              <cargo-advance-select
                ref="secondaryCustomJobType"
                no="secondaryCustomJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :cache="false"
                :default-value="form.secondaryCustomJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="secondaryCustomJobTypeList"
                @parentCallBack="p=>{form.secondaryCustomJobType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BookingAgent')">
              <cargo-advance-select
                :disabled="!lclslaveEnabled"
                no="bookingAgent"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{companyLob:'railwayExport',bookingAgent:true,active:true}"
                filterable
                :default-value="form.bookingAgent||''"
                @parentCallBack="p=>{form.bookingAgent=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.portAgent')">
              <cargo-advance-select
                :disabled="!lclslaveEnabled"
                no="portAgent"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{companyLob:'railwayExport',portAgent:true,active:true}"
                filterable
                :default-value="form.portAgent||''"
                @parentCallBack="p=>{form.portAgent=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.forwardingAgent')">
              <cargo-advance-select
                :disabled="!lclslaveEnabled"
                no="forwardingAgent"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{companyLob:'railwayExport',forwardingAgent:true,active:true}"
                filterable
                :default-value="form.forwardingAgent||''"
                @parentCallBack="p=>{form.forwardingAgent=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.destinationAgent')">
              <el-tooltip
                :content="destinationAgentTip"
                :disabled="!showDestinationAgentWarning"
                placement="right-end"
              >
                <cargo-company-select
                  ref="destinationAgent"
                  no="destinationAgent"
                  :disabled="!lclslaveEnabled"
                  :method-params="{overseaAgent:true,active:true,companyLob:'railwayExport'}"
                  :check-credit="true"
                  :job="form"
                  :default-value="form.destinationAgent||''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"

                  @change="p=>{pm.txtDestinationAgentChangeHandler(p)}"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item
              v-show="form.cargoSource==='NC'"
              :label="$t('SeaExport.NominatedAgent')"
            >
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="showWarningImageA"
                  :content="warningImageATip"
                  placement="right-end"
                >
                  <i
                    class="el-icon-warning red"
                    style="cursor: pointer"
                  />
                </el-tooltip>
                <cargo-advance-select
                  no="designationAgent"
                  :select-type="selectTypeNames.basic_data_Company"
                  :disabled="!designationAgentEnabled"
                  :method-params="{designationAgent:true,active:true}"
                  :check-credit="true"
                  :default-value="form.designationAgent||''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
                />
                <cargo-advance-select
                  v-if="overseaAgentDataProviderChange"
                  no="designationAgent2"
                  :select-type="selectTypeNames.basic_data_Company"
                  :cache="false"
                  :disabled="!designationAgentEnabled"
                  :check-credit="true"
                  :default-value="form.designationAgent||''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  :static-options="pm.designationAgentArray"
                  @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TransportSource')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_TransportSource"
                no="transportSource"
                :default-value="form.transportSource"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>form.transportSource=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ServiceStatisticalArea')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_StatisticArea"
                no="statisticArea"
                :default-value="form.statisticArea"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>form.statisticArea=item.value"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="right">
            <span class="title">{{ $t('SeaExport.AdditionalInformation') }}</span>
            <el-form-item :label="$t('SeaExport.LocalService')">
              <el-checkbox
                v-model="form.warehousing"
                no="warehousing"
                @change="pm.loadingTermChange('warehousing')"
              >{{ $t('SeaExport.WarehouseLoadingStorage') }}</el-checkbox>
              <el-checkbox
                v-model="form.landTransportation"
                no="landTransportation"
                @change="pm.loadingTermChange('landTransportation')"
              >{{ $t('SeaExport.DoorLoadingDelivery') }}</el-checkbox>
              <el-checkbox
                v-model="form.selfDeliver"
                no="selfDeliver"
              >{{ $t('SeaExport.NotResponsibleForTruckingAndLoading') }}</el-checkbox>
            </el-form-item>
            <el-form-item v-if="!isFba && isBookingNew && form.destinationPortService" :label="$t('SeaExport.PortOfDestinationServices')">
              <el-checkbox
                v-model="form.dischargingPortDoor"
                no="dischargingPortDoor"
                style="display: block;"
              >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.usCustomsClearance"
                no="usCustomsClearance"
                style="display: block;"
              >{{ $t('queryJob.UsCustomsClearance') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item v-if="isFba && isBookingNew && form.destinationPortService" :label="$t('SeaExport.PortOfDestinationServices')">
              <el-checkbox-group v-model="selectedPodAddedService" @change="addedServiceChangeHandler">
                <el-checkbox
                  v-for="item in podAddedService"
                  :key="item.code"
                  :label="item.code"
                  style="display:block"
                  @change="val => singleAddedServiceChangeHandler(val, item)"
                >
                  {{ item.chineseName }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WarehouseNo')">
              <el-input v-model="form.warehouseNo" no="warehouseNo" style="margin-bottom: 10px;" />
              <!-- 无效的按钮（和cargo保持一致，暂不移除） -->
              <el-button
                :disabled="true"
                no="ObtainTheWarehouseNo"
                type="primary"
                style="padding-left:13px;padding-right:13px;"
              >{{ $t('SeaExport.ObtainTheWarehouseNo') }}</el-button>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">
                {{ $t('RailwayExport.paymentMethod') }}
              </span>
              <cargo-advance-select
                no="paymentMethod"
                :select-type="selectTypeNames.basic_data_PaymentMethod"
                :method-params="{companyLob:'railwayExport',paymentMethod:true,active:true}"
                filterable
                :default-value="form.paymentMethod"
                :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
                :tag-value="'code'"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="p=>{form.paymentMethod=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.mbl')">
              <el-input v-model="form.mbl" no="mbl" />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.vessel')">
              <el-input v-model="form.vessel" no="vessel" />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.voyageFlight')">
              <el-input v-model="form.voyageFlight" no="voyageFlight" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBusinessNo')">
              <el-input :value="form.lclMaster?form.lclMaster.jobNo:''" :disabled="true" no="MblNo3" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BusinessReferenceNo')">
              <cargo-input v-model="form.customerRefNo" no="customerRefNo" :trim="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ItemNo')" :class="poNoRed?'poNoClass':''">
              <el-input
                v-if="!openProjectConfig"
                v-model="form.poNo"
                no="poNo"
              />
              <cargo-project-select
                v-if="openProjectConfig"
                no="poNo"
                :default-value="form.poNo"
                :customer-id="form.customerId"
                :is-linked="isProjectLinkedCustomer"
                @change="p=>{form.poNo=p.value;form.projectName=p.projectName;changeProject()}"
              />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectName')"
            >
              <el-input v-model="form.projectName" :disabled="true" />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectBatch')"
            >
              <el-input v-model="form.projectBatch" no="projectBatch" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsBroker')">
              <cargo-advance-select
                :disabled="!customsBrokerEnabled"
                no="customsBroker"
                :select-type="selectTypeNames.basic_data_Company"
                :data-filter-function="customsBrokerFilter"
                filterable
                :method-params="{customsBroker:true}"
                :default-value="form.customsBroker||''"
                :placeholder="form.customs?$t('CargoMsg.Cargo_keyWordsTip'):$t('SeaExport.PleaseTickCustomsDeclarationOption')"
                @parentCallBack="p=>{pm.customsBrokerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="!isFba" :label="$t('SeaExport.CustomsDeclarationMethod')">
              <cargo-advance-select
                no="customsMethod"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:2}"
                tag-value="serialNum"
                filterable
                :default-value="form.customClaim"
                @parentCallBack="p=>{form.customClaim=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationType')">
              <cargo-advance-select
                no="customsDeclarationType"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
                filterable
                :default-value="form.customsDeclarationType===-1?'':form.customsDeclarationType"
                :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
                @parentCallBack="p=>{form.customsDeclarationType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                no="tradeTerm"
                filterable
                :select-type="selectTypeNames.basic_data_TradeTerm"
                callback-method-type="value"
                :default-value="form.tradeTerm"
                :callback-params="{key:'tradeTerm'}"
                @parentCallBack="p=>{form.tradeTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms2')">
              <cargo-advance-select
                no="incoTerm"
                filterable
                :clearable="false"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                callback-method-type="value"
                :default-value="form.incoTerm"
                :callback-params="{key:'incoTerm'}"
                placeholder=" "
                @parentCallBack="p=>{form.incoTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HaulageCompany')">
              <cargo-company-select
                :disabled="!form.landTransportation"
                no="carryingCmp"
                :method-params="{truckCmp:true,active:true}"
                :default-value="form.carryingCmp||''"
                :placeholder="form.landTransportation?$t('CargoMsg.Cargo_keyWordsTip'):$t('SeaExport.PleaseTickDoorLoadingDeliveryOption')"
                @change="p=>{pm.carryingCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.TransportationTerms')">
              <cargo-advance-select
                no="freightTerm"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                filterable
                :clearable="false"
                :default-value="form.freightTerm"
                @parentCallBack="p=>{form.freightTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="isFba ? $t('RailwayExport.DomesticWarehouse') : (openWarehouse ? $t('SeaExport.WarehouseSupplier') : $t('SeaExport.Warehouse'))">
              <cargo-company-select
                :disabled="!warehouseEabled"
                no="warehouseCmp"
                :method-params="{warehouse:true,active:true}"
                :default-value="isFba ? Number(fbaJob.domesticWarehouse)||'' : form.warehouseCmp||''"
                :placeholder="form.warehousing?$t('CargoMsg.Cargo_keyWordsTip'):$t('SeaExport.PleaseSelectWarehouse')"
                @change="p=>{pm.warehouseCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="openWarehouse && !isFba" :label="$t('SeaExport.WareHouseName')">
              <el-select
                ref="warehouseName"
                v-model="form.warehouseName"
                no="warehouseName"
                :disabled="!warehouseEabled||!form.warehouseCmp"
                :allow-create="true"
                filterable
                :clearable="true"
                @change="warehouseNameChangeHandler"
              >
                <el-option
                  v-for="(item,index) in warehouseNameList"
                  :key="index"
                  :label="item.warehouseName"
                  :value="item.warehouseName"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('RailwayExport.OverseasWarehouse')">
              <cargo-advance-select
                no="overseaWarehouseCode"
                :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                filterable
                :method-params="{ifFba:false}"
                :clearable="false"
                tag-name="countryChineseName"
                tag-value="warehouseCode"
                :default-value="form.overseaWarehouseCode"
                style="width:100%;"
                @parentCallBack="p=>{form.overseaWarehouseCode=p.value}"
              />
            </el-form-item>
            <el-checkbox
              v-model="form.diffPlacesCollaborate"
              no="diffPlacesCollaborate"
              class="blue"
            >{{ $t('RailwayExport.isDiffPlacesCollaborate') }}</el-checkbox>
            <el-form-item :label="$t('RailwayExport.loadingPlaceCompany')">
              <cargo-company-select
                :disabled="!lclslaveEnabled"
                no="loadingPlaceCompany"
                :method-params="{companyLob:'railwayExport',loadingPlaceCompany:true,active:true}"
                :check-credit="true"
                :job="form"
                :tooltip="true"
                tooltip-tag-name="englishName"
                :default-value="form.loadingPlaceCompany||''"
                @change="p=>{form.loadingPlaceCompany=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.signBillPlaceCompany')">
              <cargo-company-select
                :disabled="!lclslaveEnabled"
                no="signBillPlaceCompany"
                :method-params="{companyLob:'railwayExport',signBillPlaceCompany:true,active:true}"
                :check-credit="true"
                :job="form"
                :tooltip="true"
                tooltip-tag-name="englishName"
                :default-value="form.signBillPlaceCompany||''"
                @change="p=>{form.signBillPlaceCompany=p.value}"
              />
            </el-form-item>
            <el-checkbox
              v-model="form.fullShipment"
              :disabled="!lclslaveEnabled"
              no="fullShipment"
              class="blue"
            >{{ $t('RailwayExport.isFullShipment') }}</el-checkbox>
            <el-form-item :label="$t('RailwayExport.dischargePortCompany')">
              <cargo-company-select
                :disabled="!lclslaveEnabled"
                no="dischargePortCompany"
                :method-params="{companyLob:'railwayExport',dischargePortCompany:true,active:true}"
                :check-credit="true"
                :job="form"
                :tooltip="true"
                tooltip-tag-name="englishName"
                :default-value="form.dischargePortCompany||''"
                @change="p=>{form.dischargePortCompany=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.destinationPortCompany')">
              <cargo-company-select
                :disabled="!lclslaveEnabled"
                no="destinationPortCompany"
                :method-params="{companyLob:'railwayExport',destinationPortCompany:true,active:true}"
                :check-credit="true"
                :job="form"
                :tooltip="true"
                tooltip-tag-name="englishName"
                :default-value="form.destinationPortCompany||''"
                @change="p=>{form.destinationPortCompany=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_BoxOneWay')">
              <el-select v-model="form.boxOneWay" no="boxOneWay">
                <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" :value="0" />
                <el-option :label="$t('CargoMsg.Cargo_OneWay')" :value="1" />
                <el-option :label="$t('CargoMsg.Cargo_Circulation')" :value="2" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form
            :disabled="readonly"
            label-width="100px"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.ContainerInfo2') }}</span>
            <el-form-item
              v-if="form.containerLoadType==='FCL'||form.containerLoadType==='BB'"
              label-width="0"
              class="auto-width"
            >
              <booking-sea-eq-data-grid
                ref="bookingSeaEqDataGrid"
                :value="seaEqList"
                :container-load-type="form.containerLoadType"
                :hide-soc="true"
                :is-edit="isEdit"
                :job="form"
              />
            </el-form-item>
            <el-form-item
              v-if="form.containerLoadType==='BULK'"
              label-width="0"
              class="auto-width"
            >
              <booking-bulk-data-grid
                :value="cargoBulkDetailList"
                :job-uuid="form.uuid"
                :is-edit="isEdit"
              />
            </el-form-item>
            <el-form-item
              v-if="form.containerLoadType==='SPA'"
              label-width="0"
              class="auto-width"
            >
              <booking-special-data-grid
                :value="seaEqList"
                :hide-eq-type="true"
                :hide-soc="true"
                :is-edit="isEdit"
                :job="form"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.QuantityConsignActual')">
              <div style="display: flex">
                <auto-number-input
                  v-model="form.quantityContract"
                  no="quantityContract"
                  :precision="0"
                  :min="0"
                  @change="pm.jobContractQwcChange(1);calcEstVolumetricAndChargeWeight()"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="quantityActual"
                  v-model="form.quantityActual"
                  :disabled="pm.billChargeFlag"
                  no="quantityActual"
                  :precision="0"
                  :min="0"
                  @change="SEUtils.changeQWCRule(null,()=>{form.quantityContract=form.quantityActual});pm.changeSynBillOfLadingQWC();pm.refContainerUsageQwc(2);quantityActualChange()"
                />
                <span style="width:65px;">PCS</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WeightConsignActual')">
              <div style="display: flex">
                <auto-number-input
                  v-model="form.weightContract"
                  no="weightContract"
                  :precision="3"
                  :min="0"
                  @change="weightContractChange();calcEstVolumetricAndChargeWeight()"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="weightActual"
                  v-model="form.weightActual"
                  no="weightActual"
                  :precision="3"
                  :min="0"
                  :disabled="pm.billChargeFlag"
                  @change="weightActualChange"
                />
                <span style="width:65px;">KGS</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CubageConsignActual')">
              <div style="display: flex">
                <auto-number-input
                  v-model="form.cubageContract"
                  no="cubageContract"
                  :precision="3"
                  :min="0"
                  @change="cubageContractChange();calcEstVolumetricAndChargeWeight()"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="cubageActual"
                  v-model="form.cubageActual"
                  no="cubageActual"
                  :precision="3"
                  :min="0"
                  :disabled="!cubageActualEnabled"
                  @change="cubageActualChange"
                />
                <span style="width:65px;">CBM</span>
              </div>
            </el-form-item>
            <el-form-item
              v-if="isFba"
              :label="$t('SeaExport.VolumetricWeightConsignActual')"
            >
              <div style="display: flex">
                <auto-number-input
                  v-model="form.volumetricWeightContract"
                  no="volumetricWeightContract"
                  :precision="3"
                  :min="0"
                  @change="calcEstVolumetricAndChargeWeight(form.volumetricWeightContract)"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="volumetricWeight"
                  v-model="form.volumetricWeight"
                  no="volumetricWeight"
                  :precision="3"
                  :min="0"
                  @change="changeVolumetricWeight"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item
              v-if="isFba"
              :label="$t('SeaExport.ChargeWeightConsignActual')"
            >
              <div style="display: flex">
                <auto-number-input
                  v-model="form.chargeWeightContract"
                  no="chargeWeightContract"
                  :precision="3"
                  :min="0"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="chargeWeight"
                  v-model="form.chargeWeight"
                  no="chargeWeight"
                  :precision="3"
                  :min="0"
                  @change="changeChargeWeight"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item v-if="isFba" label-width="0">
              <div style="display: flex;justify-content: space-around">
                <el-checkbox v-model="fbaJob.electric" style="margin-right: 10px;margin-left: 20px;">{{ $t('RailwayExport.WithBattery') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.magnetic" style="margin-right: 10px;">{{ $t('RailwayExport.WithMagnet') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.powdery" style="margin-right: 10px;">{{ $t('RailwayExport.Powder') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.liquid" style="margin-right: 10px;">{{ $t('RailwayExport.Liquid') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item
              v-show="form.containerLoadType==='BULK'"
              :label="$t('SeaExport.QuantitySize')"
            >
              <el-input-number
                v-model="form.insideQuantitySize"
                no="insideQuantitySize"
                :precision="0"
                :controls="false"
                style="width:100%;"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')">
              <cargo-packing-select
                no="packing"
                :default-value="form.packing"
                @change="p=>{form.packing=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.ChineseDescriptionOfGoods') }}</span>
                <br>
                <el-button
                  v-show="isEdit"
                  no="SelectCargoChineseName"
                  type="primary"
                  @click="showHsCodeSearchDialog($t('Message.SelectCargoChineseName'),p=>{form.cargoChineseName=p.commodityName})"
                >{{ $t('SeaExport.Search') }}</el-button>
              </div>
              <cargo-rich-textarea
                v-model="form.cargoChineseName"
                no="cargoChineseName"
                :disabled="readonly"
                :text-chars="0"
                style="height: 110px"
                :class="form.cargoChineseNameWarning === 1 ? 'red-border' : ''"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),form.cargoChineseName,false,val=>{form.cargoChineseName=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')">
              <cargo-rich-textarea
                v-model="form.cargoEnglishName"
                no="cargoEnglishName"
                :show-count="true"
                :disabled="readonly"
                :auto-uppercase="isUppercaseByConfig"
                :text-chars="0"
                :class="form.cargoEnglishNameWarning === 1 ? 'red-border' : ''"
                style="height: 110px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,isUppercaseByConfig,val=>{form.cargoEnglishName=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Marks')">
              <cargo-rich-textarea
                v-model="form.mark"
                :disabled="readonly"
                no="mark"
                :show-count="true"
                :text-chars="0"
                :auto-uppercase="isUppercaseByConfig"
                style="height: 110px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,isUppercaseByConfig,val=>{form.mark=val})"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="right">
            <span class="title">{{ $t('SeaExport.OperationInfo') }}</span>
            <el-form-item>
              <span slot="label" class="blue">
                {{ $t('SeaExport.SalesCompany') }}
              </span>
              <el-input :value="txtSalesOffice" :disabled="true" no="txtSalesOffice" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">
                {{ $t('SeaExport.Sales') }}
              </span>
              <div style="display: flex;justify-content: space-between">
                <cargo-user-select
                  ref="sales"
                  :disabled="!saleEnabled"
                  no="salesRecord"
                  :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                  :default-value="form.sales||''"
                  :static-options="salesList"
                  :placeholder="salesPrompt"
                  :merge-load="true"
                  style="flex: 1"
                  @change="p=>{form.salesRecord = p.value;pm.salesChangeHandler(p);}"
                />&nbsp;
                <el-checkbox
                  v-model="form.provisioned"
                  no="provisioned"
                  style="margin-left: 5px"
                  :disabled="true"
                >{{ $t('SeaExport.Accrued') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="cargoSalesId"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="form.cargoSalesId||''"
                :merge-load="true"
                :static-options="cargoSalesList"
                @change="p=>{form.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">
                {{ $t('SeaExport.SalesDepartment') }}
              </span>
              <cargo-department-new-select
                :disabled="!form.sales"
                no="salesDepartment"
                :enables="true"
                :sales-id="Number(form.sales)"
                :office-id="form.salesOffice"
                :department-id="Number(form.salesDepartment)"
                @change="p=>{form.salesDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-office-select
                :disabled="(!isRegionalCommission && pm.isEntrustOrder(true)) || opOfficeDisabled"
                :is-regional-commission="isRegionalCommission"
                no="opOffice"
                :office-id="Number(form.opOffice)"
                @change="p=>{form.opOffice=p.value;form.opDepartment=0;opOfficeChargeHandler();contractRuleFieldChange(form.customerId, form.designationAgent)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">
                {{ $t('SeaExport.OperationDepartment') }}
              </span>
              <cargo-department-select
                :disabled="pm.isWithinCloseAccountDate"
                no="opDepartment"
                :enables="true"
                :office-id="Number(form.opOffice)"
                :department-id="Number(form.opDepartment)"
                @change="p=>{form.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">
                {{ $t('SeaExport.Operation') }}
              </span>
              <cargo-user-select
                :disabled="!opEabled"
                no="op"
                :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
                :default-value="form.op||''"
                :merge-load="true"
                :static-options="userPortRoleData.op"
                @change="p=>{form.op=p.value;pm.txtOPChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-office-select
                no="csrOffice"
                :disabled="true"
                :office-id="Number(form.csrOffice)"
                @change="p=>{form.csrOffice=p.value;form.csrDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Customer_Service') }}</span>
              <cargo-department-select
                no="csrDepartment"
                :office-id="Number(form.csrOffice)"
                :enables="true"
                :department-id="Number(form.csrDepartment)"
                @change="p=>{form.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                ref="csr"
                no="csr"
                :method-params="{officeId:pm.isEntrustOrder||form.salesOffice===1?form.opOffice:form.salesOffice,category:'role',shape:'csr'}"
                :default-value="form.csr||''"
                :merge-load="true"
                :static-options="userPortRoleData.csr"
                @change="p=>{pm.csrChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                :method-params="{officeId:form.opOffice,category:'role',shape:'siteOp'}"
                :default-value="form.siteOP||''"
                :static-options="userPortRoleData.siteOp"
                @change="p=>{JobUtils.siteOpChangeHandler(form, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <cargo-user-select
                ref="overseaOp"
                no="overseaOp"
                :method-params="{category:'role',shape:'overseaOp'}"
                :default-value="form.overseaOp||''"
                :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
                :merge-load="true"
                @change="p=>{form.overseaOp=p.value;pm.overseaOpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')">
              <cargo-office-select
                no="dcOffice"
                :disabled="true"
                :office-id="Number(form.dcOffice)"
                @change="p=>{form.dcOffice=p.value;form.dcDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Documentation_Department') }}</span>
              <cargo-department-select
                no="dcDepartment"
                :office-id="Number(form.dcOffice)"
                :enables="true"
                :department-id="Number(form.dcDepartment)"
                @change="p=>{form.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select
                ref="dc"
                no="dc"
                :method-params="{officeId:form.opOffice,category:'role',shape:'doc'}"
                :default-value="form.dc||''"
                :merge-load="true"
                :static-options="userPortRoleData.doc"
                @change="p=>{pm.dcChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.plannerOffice')">
              <cargo-office-select
                no="plannerOffice"
                :disabled="true"
                :office-id="Number(form.plannerOffice)"
                @change="p=>{form.plannerOffice=p.value;form.plannerDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('RailwayExport.plannerDepartment') }}</span>
              <cargo-department-select
                no="plannerDepartment"
                :office-id="Number(form.plannerOffice)"
                :enables="true"
                :department-id="Number(form.plannerDepartment)"
                @change="p=>{form.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.planner')">
              <cargo-user-select
                no="planner"
                :method-params="{officeId:form.opOffice,category:'role',shape:'railwayLine'}"
                :default-value="form.planner||''"
                :merge-load="true"
                :static-options="userPortRoleData.railwayLine"
                @change="p=>{form.planner=p.value;pm.txtPlannerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="form.userDefinedRoleId1||''"
                :merge-load="true"
                :static-options="userPortRoleData.userDefinedRole1"
                @change="p=>{pm.userDefinedRoleId1Handler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                ref="userDefinedRoleId2"
                no="userDefinedRoleId2"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="form.userDefinedRoleId2||''"
                :merge-load="true"
                :static-options="userPortRoleData.userDefinedRole2"
                @change="p=>{pm.userDefinedRoleId2Handler(p)}"
              />
            </el-form-item>
            <el-form-item
              label-width="0"
              class="auto-width"
            >
              <special-requests-grid
                ref="selectedSpecialRequest"
                v-model="form.satisfiedRequests"
                :is-edit="isEdit"
                :customer-id="form.customerId"
                :lob="form.lob"
                :job="form"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationRequirements')">
              <el-tooltip :content="form.operationContent" placement="left">
                <div
                  slot="content"
                  v-html="form.operationContent ? form.operationContent.replace(/[\n]/g,'</br>') : $t('SeaExport.NoData')"
                />
                <el-input
                  :value="form.operationContent"
                  no="operationContent"
                  :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddOperationRequirements')"
                  type="textarea"
                  :rows="4"
                  @dblclick.native="selectOperationReqDialog.value=form.operationContent;selectOperationReqDialog.visible=isEdit"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationTips')">
              <el-input
                v-model="form.operationTips"
                no="operationTips"
                type="textarea"
                :rows="4"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.OperationTips'),form.operationTips,false,val=>{form.operationTips=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ExtraChargeClause')">
              <el-input
                :value="txtSurchargeTerms"
                no="txtSurchargeTerms"
                :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddExtraChargeClause')"
                type="textarea"
                :rows="4"
                @dblclick.native="selectSurchargeTermsDialog.rowData=form.surchargeTerms;selectSurchargeTermsDialog.visible=true"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WarehousingInfo')">
              <el-input :disabled="true" no="txtWhs" type="textarea" :rows="4" :value="txtWhs" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Remarks')">
              <el-input
                v-model="form.remarks"
                no="remarks"
                type="textarea"
                :rows="4"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),form.remarks,false,val=>{form.remarks=val})"
              />
            </el-form-item>
          </el-form>
        </div>

        <!-- FBA相关信息-->
        <div v-if="isFba" class="section form-column">
          <el-form
            :disabled="readonly"
            label-width="120px"
            label-position="right"
          >
            <span class="title">{{ 'FBA' }}</span>
            <el-form-item v-if="!isEdit" :label="$t('RailwayExport.ServiceChannel')">
              <cargo-advance-select
                no="serviceChannel"
                disabled
                :select-type="selectTypeNames.basic_data_FbaChannel"
                filterable
                :method-params="{shippingType: fbaJob.shippingType, active: true}"
                :clearable="true"
                :default-value="fbaJob.serviceChannel"
                @parentCallBack="p=>{fbaJob.serviceChannel=p.value;}"
              />
            </el-form-item>
            <el-form-item v-if="isEdit" :label="$t('RailwayExport.ServiceChannel')">
              <el-select v-model="fbaJob.serviceChannel" filterable clearable @change="changeServiceChannel">
                <el-option
                  v-for="(item,index) in channel4JobSelect"
                  :key="index"
                  :label="item.channelName"
                  :value="item.channelName"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('RailwayExport.EstimatedStoragegoodReadyTime') }}</span>
              <el-date-picker
                v-model="fbaJob.preWarehousingTime"
                no="preWarehousingTime"
                type="datetime"
                style="width:100%;"
                clearable
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                @change="pm.preWarehousingChangeHandler()"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.ExpectedToEnterAmazonWarehouse')">
              <el-date-picker
                v-model="fbaJob.preAmazonWhTime"
                no="preAmazonWhTime"
                :disabled="readonly"
                type="date"
                style="width:100%;"
                clearable
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_Destination') }}</span>
              <div style="display: flex; flex: 1;">
                <el-tooltip :content="fbaJob.warehouseCode" placement="bottom-end">
                  <el-cascader
                    v-model="fbaJob.warehouseCode"
                    style="padding-right: 2px;"
                    :options="destinations"
                    filterable
                    :clearable="true"
                    @focus="JobUtils.focusWarehouseCode(fbaJob)"
                    @blur="JobUtils.blurWarehouseCode(fbaJob)"
                    @change="p=>{JobUtils.warehouseCodeHandler(fbaJob, p);changeWarehouseCode}"
                  />
                </el-tooltip>
                <el-checkbox v-model="fbaJob.remoteWarehouse" no="remoteWarehouse">{{ $t('RailwayExport.RemoteWarehouse') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Warehouse.DestinationCountry')">
              <el-input v-model="fbaJob.country" :disabled="true" no="country" />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.PostalCode')">
              <el-input v-model="fbaJob.zipCode" :disabled="true" no="zipCode" />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.DestinationDeliveryMethod')">
              <el-select v-model="fbaJob.destinationDistribution" no="destinationDistribution" filterable @change="destinationDistributionChange">
                <el-option
                  v-for="(item,index) in FbaJobConstants.ORDER_DESTINATION_DISTRIBUTION_TYPES"
                  :key="index"
                  :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('RailwayExport.ExpressCompany')">
              <el-select v-model="fbaJob.expressCompany" no="expressCompany" placeholder="" clearable>
                <el-option
                  v-for="item in FbaJobConstants.EXPRESS_COMPANYS"
                  :key="item.code"
                  :label="item.chineseName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('RailwayExport.TrackingNumber')">
              <el-input v-model="fbaJob.expressNo" no="expressNo" />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.POoriginalOrderNumber')">
              <el-input v-model="fbaJob.poNumber" no="poNumber" />
            </el-form-item>
            <el-form-item :label="'Shipment Id'">
              <el-input v-model="fbaJob.shipmentId" no="shipmentId" />
            </el-form-item>
            <el-form-item :label="'Reference Id'">
              <el-input v-model="fbaJob.referenceId" no="referenceId" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('FbaJob.ChargingMethod') }}</span>
              <el-radio-group v-model="fbaJob.chargingMethod" no="chargingMethod" @change="chargingMethodChange">
                <el-radio :label="'0'">{{ 'KG' }}</el-radio>
                <el-radio :label="'1'">{{ 'CBM' }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('FbaChannel.bubbleCountingRatio')">
              <!--              <el-input-number v-model="fbaJob.bubbleCountingRatio" no="bubbleCountingRatio" controls-position="right" :max="999999" :min="0" style="width: 100%;" />-->
              <el-input v-model="fbaJob.bubbleCountingRatio" no="bubbleCountingRatio" style="width: 100%;" @change="bubbleCountingChange" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.pbProportion')">
              <div style="display: flex; flex: 1;">
                <!--                <el-input-number v-model="fbaJob.bubbleSplittingRatio" no="bubbleSplittingRatio" controls-position="right" :max="10" :min="0" :precision="0" />%-->
                <el-input v-model="fbaJob.bubbleSplittingRatio" no="bubbleSplittingRatio" @change="bubbleSplittingRatioChange" />%
              </div>
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.CustomsDeclarationMethod')">
              <cargo-advance-select
                no="customsMethodPol"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:0}"
                filterable
                :clearable="false"
                :default-value="fbaJob.customsMethodPol"
                @parentCallBack="p=>{fbaJob.customsMethodPol=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.CustomsClearanceMethod')">
              <cargo-advance-select
                no="customsMethodPod"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:1}"
                filterable
                :clearable="false"
                :default-value="fbaJob.customsMethodPod"
                @parentCallBack="p=>{fbaJob.customsMethodPod=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.EORIEnterpriseNumber')">
              <el-input v-model="fbaJob.eoriNo" no="eoriNo" />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.VATtaxNumber')">
              <el-input v-model="fbaJob.vatNo" no="vatNo" />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.VATRegistrationCountry')">
              <cargo-advance-select
                no="taxRegisterCountry"
                :select-type="selectTypeNames.basic_data_Country"
                filterable
                :callback-params="{key:'taxRegisterCountry'}"
                callback-method-type="value"
                :default-value="fbaJob.taxRegisterCountry"
                @parentCallBack="p=>{fbaJob.taxRegisterCountry = p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.VATRegistrationAddress')">
              <el-input v-model="fbaJob.taxRegisterAddress" no="taxRegisterAddress" />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.VATCompanyEnglishName')">
              <el-input v-model="fbaJob.taxCompany" no="taxCompany" />
            </el-form-item>

            <hr style="margin-top: 20px;margin-bottom: 20px;">
            <span class="title">{{ $t('SeaExport.PODDeliveryInformation') }}</span>
            <el-form-item :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToWarehouseTime')">
              <el-date-picker
                v-model="form.estWarehouseDeliveryTime"
                no="estWarehouseDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToWarehouseTime')">
              <el-date-picker
                v-model="form.actWarehouseDeliveryTime"
                no="actWarehouseDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseTime')">
              <el-date-picker
                v-model="form.estGoodsDeliveryTime"
                no="estGoodsDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.ActualDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToCustomersWarehouseTime')">
              <el-date-picker
                v-model="form.actGoodsDeliveryTime"
                no="actGoodsDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.EstimatedDeliveryTime')">
              <el-date-picker
                v-model="form.estDeliveryTime"
                no="estDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.ActualDeliveryTime')">
              <el-date-picker
                v-model="form.actDeliveryTime"
                no="actDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EstimatedReturnTime')">
              <el-date-picker
                v-model="form.estReturnTime"
                no="45"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualReturnTime')">
              <el-date-picker
                v-model="form.actReturnTime"
                no="46"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>
        </div>

        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="right">
            <span class="title">{{ $t('SeaExport.UserDefinedArea') }}</span>
            <el-form-item :label="$t('SeaExport.UserDefinedField1')">
              <el-input
                v-model="form.userDefinedField1"
                no="userDefinedField1"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField1'),form.userDefinedField1,false,val=>{form.userDefinedField1=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField2')">
              <el-input
                v-model="form.userDefinedField2"
                no="userDefinedField2"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField2'),form.userDefinedField2,false,val=>{form.userDefinedField2=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField3')">
              <el-input
                v-model="form.userDefinedField3"
                no="userDefinedField3"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),form.userDefinedField3,false,val=>{form.userDefinedField3=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField4')">
              <el-input
                v-model="form.userDefinedField4"
                no="userDefinedField4"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),form.userDefinedField4,false,val=>{form.userDefinedField4=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TaxNature')">
              <el-select
                v-model="form.taxNature"
                no="taxNature"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in TAX_NATURES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="section">
        <div class="form-row">
          <span class="title">{{ $t('SeaExport.CustomerDeliveryInfo') }}</span>
          <div style="display: flex; flex-direction: row;">
            <el-form
              :disabled="readonly"
              label-width="50px"
              label-position="right"
              style="position:relative;margin-right: 10px"
            >
              <char-count :form="form" prefix="shipper" />
              <el-form-item :label="$t('SeaExport.Shipper')">
                <cargo-company-select
                  no="shipperId"
                  :method-params="{shipper:true,active:true}"
                  :default-value="form.shipperId||''"
                  style="display: inline-block;width: 175px;"
                  @change="data => {pm.shipperChange(data)}"
                />&nbsp;
                <el-button
                  v-if="!isFba"
                  no="shipperBillAddress"
                  type="primary"
                  @click="billAddressDialog.visible=true"
                >{{ $t('SeaExport.CodeSearching') }}</el-button>
                <el-button v-if="isFba" no="shipperBillAddress" :disabled="readonly" type="primary" @click="fbaCodeSearchBtn">{{ $t('SeaExport.CodeSearching') }}</el-button>
              </el-form-item>
              <el-form-item v-for="i in 7" :key="i" label-width="0">
                <cargo-input
                  :ref="'shipperLine'+i"
                  v-model="form['shipperLine'+i]"
                  :no="'shipperLine'+i"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  @change="()=>wrapAddr(form,'shipperLine'+i,i+1 > 6 ? null :'shipperLine'+(i+1),'')"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),notUppercaseShipperConsigneNotify,splitShipperLine)"
                />
              </el-form-item>
            </el-form>
            <el-form
              :disabled="readonly"
              label-width="50px"
              label-position="right"
              style="position:relative;margin-right:10px"
            >
              <char-count :form="form" prefix="consignee" />
              <el-form-item :label="$t('SeaExport.Consignee')">
                <cargo-company-select
                  no="consigneeId"
                  :method-params="{consignee:true,active:true}"
                  :default-value="form.consigneeId||''"
                  style="display: inline-block;width:175px;"
                  @change="data => {pm.consigneeChange(data)}"
                />&nbsp;
                <el-button
                  v-if="!isFba"
                  no="consigneeBillAddress"
                  type="primary"
                  @click="billAddressDialog.visible=true"
                >{{ $t('SeaExport.CodeSearching') }}</el-button>
                <el-button v-if="isFba" no="consigneeBillAddress" :disabled="readonly" type="primary" @click="fbaCodeSearchBtn">{{ $t('SeaExport.CodeSearching') }}</el-button>
              </el-form-item>
              <el-form-item v-for="i in 7" :key="i" label-width="0">
                <cargo-input
                  :ref="'consigneeLine'+i"
                  v-model="form['consigneeLine'+i]"
                  :no="'consigneeLine'+i"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  @change="()=>wrapAddr(form,'consigneeLine'+i,i+1 > 6 ? null :'consigneeLine'+(i+1),'')"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),notUppercaseShipperConsigneNotify,splitConsigneeLine)"
                />
              </el-form-item>
            </el-form>
            <el-form
              :disabled="readonly"
              label-width="50px"
              label-position="right"
              style="position:relative;margin-right:10px"
            >
              <char-count :form="form" prefix="notify" />
              <el-form-item :label="$t('SeaExport.NotifyParty')">
                <cargo-company-select
                  no="notifyId"
                  :method-params="{notify:true,active:true}"
                  :default-value="form.notifyId||''"
                  style="display: inline-block;width:175px;"
                  @change="data => {pm.notifyChange(data)}"
                />&nbsp;
                <el-button
                  v-if="!isFba"
                  no="noconifyBillAddress"
                  type="primary"
                  @click="billAddressDialog.visible=true"
                >{{ $t('SeaExport.CodeSearching') }}</el-button>
                <el-button v-if="isFba" no="noconifyBillAddress" :disabled="readonly" type="primary" @click="fbaCodeSearchBtn">{{ $t('SeaExport.CodeSearching') }}</el-button>
              </el-form-item>
              <el-form-item v-for="i in 7" :key="i" label-width="0">
                <cargo-input
                  :ref="'notifyLine'+i"
                  v-model="form['notifyLine'+i]"
                  :no="'notifyLine'+i"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  @change="()=>wrapAddr(form,'notifyLine'+i,i+1 > 6 ? null :'notifyLine'+(i+1),'')"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),notUppercaseShipperConsigneNotify,splitNotifyLine)"
                />
              </el-form-item>
            </el-form>
            <div>
              <span
                style="display:inline-block;line-height:28px;padding-bottom: 10px;"
              >{{ $t('SeaExport.SecondNotifyParty') }}</span>
              <cargo-rich-textarea
                v-model="form.alsoNotify"
                :disabled="readonly"
                no="alsoNotify"
                :text-chars="0"
                style="width: 310px;height: 230px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.SecondNotifyParty'),form.alsoNotify,notUppercaseShipperConsigneNotify,val=>{form.alsoNotify=val})"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 联系人弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="contact"
      :visible.sync="contactDialog.visible"
      :title="$t('SeaExport.ContactPerson')"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-position="right" label-width="100px">
        <el-form-item :label="$t('SeaExport.ContactPerson')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.contactPerson"
            no="contactPerson"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Role')+'：'">
          <el-input :disabled="true" :value="contactDialog.data.role" no="role" style="width: 170px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Tel')+'：'">
          <el-input :disabled="true" :value="contactDialog.data.telephone" no="telephone" style="width: 170px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Mobile')+'：'">
          <el-input :disabled="true" :value="contactDialog.data.mobile" no="mobile" style="width: 170px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Fax')+'：'">
          <el-input :disabled="true" :value="contactDialog.data.fax" no="fax" style="width: 170px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Email')+'：'">
          <el-input :disabled="true" :value="contactDialog.data.email" no="email" style="width: 170px;" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Remarks')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.remarks"
            no="remarks"
            type="textarea"
            :rows="3"
            style="width: 170px;"
          />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceText"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :warning-count="-1"
        :text-chars="0"
        :auto-uppercase="advanceTextDialog.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="confirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- HS编号和中文品名检索弹窗 -->
    <hs-code-search-dialog
      :visible.sync="hsCodeSearchDialog.visible"
      :title="hsCodeSearchDialog.title"
      :hide-country-code="true"
      @callback="hsCodeSearchDialog.successCallback"
    />
    <!-- 操作要求弹窗 -->
    <select-operation-req-dialog
      :visible.sync="selectOperationReqDialog.visible"
      lob="RE"
      :value="selectOperationReqDialog.value"
      @callback="val=>{form.operationContent=val}"
    />
    <!-- 附加费条款弹窗 -->
    <select-surcharge-terms-dialog
      :visible.sync="selectSurchargeTermsDialog.visible"
      :job-uuid="form.uuid"
      :row-data="selectSurchargeTermsDialog.rowData"
      :disabled="readonly"
      @callback="handleSurchargeTerms"
    />
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="form"
      @callback="codeSearchCallback"
    />
    <!-- Fba收发通地址弹窗 -->
    <fba-bill-address-dialog
      :visible.sync="fbaBillAddressDialog.visible"
      :job="fbaJob"
      @callback="fbaCodeSearchCallback"
    />
    <!-- 订舱章弹窗 -->
    <stamp-picture-view
      :visible.sync="stampPictureView.visible"
      :business-documents="stampPictureView.businessDocuments"
    />
  </div>
</template>

<script>
import { TabBookingFCLPM } from './tabBookingFCLPM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import bookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import bookingBulkDataGrid from '@/components/Cargo/Job/bookingBulkDataGrid'
import bookingSpecialDataGrid from '@/components/Cargo/Job/bookingSpecialDataGrid'
import hsCodeSearchDialog from '@/components/Cargo/Job/hsCodeSearchDialog'
import specialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'
import selectOperationReqDialog from '@/components/Cargo/Job/selectOperationReqDialog'
import selectSurchargeTermsDialog from '@/components/Cargo/Job/selectSurchargeTermsDialog'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import lang from '@/lang'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import ColumnUtils from '@/utils/ColumnUtils'
import { dateCompare, dateCompareYMD } from '@/utils/commonUtil'
import selectData from '@/utils/selectData'
import { CONTAINERLOAD_TYPES } from '@/class/cargo/model/parameters/ContainerLoadType'
import {
  CARGO_SOURCES,
  EXPORT_CONTROLLED_PRODUCT,
  RATE_TYPE,
  TAX_NATURES
} from '@/class/cargo/model/parameters/SystemConstants'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { PAYMENTMETHOD_TYPES } from '@/class/cargo/model/parameters/PaymentMethod'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { Contract } from '@/class/model/mdm/Contract'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { updateTrackingForDocumentType } from '@/api/fileHistory'
import { validateReleaseNumberCustomer } from '@/api/company'
import stampIcon from '@/assets/stamp.jpg'
import StampPictureView from '@/components/Cargo/Job/stampPictureView'
import { findBusinessDocument } from '@/api/seaExport/businessDocument'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import { FbaJob } from '@/class/model/booking/FbaJob'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip'
import fbaBillAddressDialog from '@/views/cargo/v0/FBA/Order/billAddressDialog'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import { getUserInfo } from '@/utils/auth'
import { getJobAvailableChannels } from '@/api/Fba/fbaChannel'
import { getCacheListByKey, getSpecificBasicDataFromCache } from '@/utils/basicDataCache'
import StrUtils from '@/utils/StrUtils'
import { searchCustomerPrice } from '@/api/price/fbaQuotation'
import { FbaQuotationUtil } from '@/class/cargo/model/utils/FbaQuotationUtil'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { Charge } from '@/class/model/act/Charge'
import BookingUtil from '@/class/cargo/model/utils/BookingUtil'
import { FbaQuotation } from '@/class/model/price/FbaQuotation'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import CargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import { checkPoNoIsExist } from '@/api/booking/job'
import { getPartnerByPoNo } from '@/api/projectManage/project'
import BasicTabMixin from '@/mixin/BasicTabMixin'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'
import moment from 'moment'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'ReTabBookingFCL',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE': return lang.t('SeaExport.TUE')
        case 'WED': return lang.t('SeaExport.WED')
        case 'THU': return lang.t('SeaExport.THU')
        case 'FRI': return lang.t('SeaExport.FRI')
        case 'SAT': return lang.t('SeaExport.SAT')
        case 'SUN': return lang.t('Pricing.Sun')
        case 'MON':
        default: return lang.t('SeaExport.MON')
      }
    }
  },
  components: {
    CargoProjectSelect,
    StampPictureView, AutoNumberInput,
    cargoAdvanceSelect, cargoInput, cargoDepartmentNewSelect, cargoDepartmentSelect, cargoOfficeSelect, cargoUserSelect,
    cargoCompanySelect, cargoPackingSelect, cargoRichTextarea, bookingSeaEqDataGrid, bookingBulkDataGrid, bookingSpecialDataGrid,
    hsCodeSearchDialog, specialRequestsGrid, selectOperationReqDialog, selectSurchargeTermsDialog, billAddressDialog, fbaBillAddressDialog,
    CargoSalesCompanySelect
  },
  mixins: [BasicTabMixin],
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    viewSource: { type: String, default: '' }, // 页面请求发起方
    cooperateEdit: { type: Boolean, default: true }, // 能否修改
    isFba: { type: Boolean, default: false }, // 是否是FBA业务
    processingPromiseList: { // 正在处理中的异步操作对象列表
      type: Array,
      default: () => []
    },
    provisionLock: {
      type: Object,
      default: () => ({ etdLocked: false, feeLocked: false })
    }
  },
  data() {
    return {
      pm: new TabBookingFCLPM(this),
      addrPM: new BillAddressCommonPM(this),
      selectTypeNames: TYPE_NAMES,
      contractStatuses: selectData.contractStatuses,
      containerLoadTypes: CONTAINERLOAD_TYPES,
      CARGO_SOURCES,
      TAX_NATURES,
      EXPORT_CONTROLLED_PRODUCT,
      PAYMENTMETHOD_TYPES,
      rateType: RATE_TYPE,
      SEUtils,
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      branchOfficeCheck: false,
      creditOpen: false,
      isTabContainerInfo: true, // CARGO-7908 当基本页签切换非装箱信息页签不去覆盖基本页签实际件毛体(cargo默认设置的是true)
      btnSave: true,
      selectedLocalAddedService: [],
      localAddedService: [],
      selectedPodAddedService: [],
      podAddedService: [],
      form: new RailwayExportJob().fillDefaultValue().getData(),
      fbaJob: new FbaJob().fillDefaultValue().getData(), // fbaJob
      tenantId: 0,
      channel4JobSelect: [],
      cargoType4JobSelect: [],
      fbaQuotation: null,
      fbaChannel: null,
      serviceChannel: null,
      chargingMethod: '',
      destinationDistribution: '',
      bubbleSplittingRatio: 0.0,
      bubbleCountingRatio: 0.0,
      customerLevel: {
        level: '',
        customerName: ''
      },
      advancePaymentLabel: '', // 预付款(中邮)
      contractStatus: 0,
      contractStatusLabel: '',
      customerTip: '',
      contactList: [],
      etdEnabled: false,
      cargoSourceEnabled: false,
      overseaAgentDataProviderChange: false, // 目的港代理数据源是否发生变更
      salesList: null,
      salesPrompt: '',
      txtWhs: '', // 入库信息
      txtSalesOffice: '', // 销售所在分公司
      overseaAgentUsersList: null, // 海外客服用户列表
      txtSurchargeTerms: '', // 附加费条款
      contactDialog: {
        visible: false,
        data: {}
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        autoUppercase: false,
        successCallback: null
      },
      hsCodeSearchDialog: {
        visible: false,
        title: '',
        successCallback: () => { }
      },
      selectOperationReqDialog: {
        visible: false,
        value: ''
      },
      selectSurchargeTermsDialog: {
        visible: false,
        rowData: []
      },
      stampIcon, // 订舱章
      stampPictureView: {
        businessDocuments: [], // 不为空则显示订舱章
        visible: false
      },
      billAddressDialog: {
        visible: false
      },
      fbaBillAddressDialog: { // Fba收发通地址
        visible: false
      },
      showWarningImageA: false,
      warningImageATip: '',
      showWarningImageB: false,
      warningImageBTip: '',
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      openWarehouse: false,
      warehouseNameList: [],
      opEabled: false,
      JobUtils,
      openProjectConfig: false, // 是否关联项目管理
      showDestinationAgentWarning: false,
      destinationAgentTip: '',
      poNoRed: false,
      needConfirmProjectNo: false,
      isProjectLinkedCustomer: false,
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        userDefinedRole3: null,
        userDefinedRole4: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      cargoSalesList: null,
      secondaryCustomJobTypeList: [],
      customJobTypeList: [],
      isZY: false, // 显示中邮选项
      isHC: false,
      isShowContactPersonDetail: false, // 海创显示详细信息
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    FbaJobConstants() {
      return FbaJobConstants
    },
    provisionEtdLocked() {
      return !!(this.provisionLock && this.provisionLock.etdLocked)
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    config() {
      return this.context.config
    },
    seaEqList() {
      return this.form.seaEQ || []
    },
    cargoBulkDetailList() {
      return this.form.cargoBulkDetail || []
    },
    lclslaveEnabled() {
      return !this.form.lclMasterUuid
    },
    customerEnabled() {
      // 开启参数1 且是被委托的业务，不可以改委托单位；
      if (this.context.config && Number(this.context.config.get('isNewDelegation')) === 1 && this.form.trustFromJob) {
        return false
      }
      return this.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'customerId')
    },
    designationAgentEnabled() {
      return this.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'designationAgent')
    },
    customsBrokerEnabled() {
      if (!this.form.customs) {
        return false
      }
      if (!SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'customsBroker')) {
        return false
      }
      return true
    },
    warehouseEabled() {
      if (!this.form.warehousing) {
        return false
      }
      if (!SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'warehouseCmp')) {
        return false
      }
      return true
    },
    cubageActualEnabled() {
      return this.isEdit && !this.pm.billChargeFlag && SecurityUtil.checkOffsetChargeMeasure(this.form, 'WCB')
    },
    saleEnabled() {
      return ((this.pm.trustFromEditSales ? true : !this.form.trustFromJob) || this.pm.isCrossTenant) &&
        this.pm.canChangeSalesOfJob && !this.pm.isWithinCloseAccountDate
    },
    destinations() { // 目的地 可选项
      return JobUtils.initDestination(this.fbaQuotation)
    },
    // 是否为铁路头程
    isBookingNew() {
      return this.$route.path.toLowerCase() === '/FBA/FBARailwayExport'.toLowerCase()
    },
    // 销售分公司
    salesOffice() {
      return this.form.salesOffice
    }
  },
  watch: {
    'form.customerId'(newVal) {
      if (this.form.fba && this.fbaJob) {
        this.fbaJob.customerId = newVal
      }
    }
  },
  async created() {
    const user = getUserInfo()
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify()
    this.isHC = String(cache.config.get('ToExoSystem')) === 'HC'
    console.log('RI->booking->created->notUppercaseShipperConsigneNotify', this.notUppercaseShipperConsigneNotify)
    this.isShowContactPersonDetail = String(this.context.config.get('ToExoSystem')) === 'HC'
    this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.tenantId = user.tenantId
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!row.uuid) {
        row.booking = true
      }
      if (this.isEdit) {
        if (this.form.uuid) {
          this.opEabled = await SecurityUtil.canEdit(this.form, false)
        } else {
          this.opEabled = true
        }
        this.setSecondaryCustomJobTypeFunc()
      }
      if (!isRefresh) {
        return
      }
      /* ****************************** 初始化 begin ****************************** */
      this.fbaQuotation = null
      this.fbaChannel = null
      this.serviceChannel = null
      this.cargoType4JobSelect = []
      this.localAddedService = []
      this.podAddedService = []
      this.selectedLocalAddedService = []
      this.selectedPodAddedService = []
      this.salesOfficeCheck = Number(this.context.config.get('SalesOfficeCheck')) === 1
      this.branchOfficeCheck = Number(this.context.config.get('departmentSalesOfficeCheck')) === 1
      this.isAddUserDefinedRoles = Number(this.context.config.get('IsAddUserDefinedRoles')) === 1
      this.creditOpen = Number(this.context.config.get('creditOpen')) === 1
      this.openWarehouse = Number(this.context.config.get('isOpenWarehouse')) > 0
      this.openProjectConfig = Number(this.context.config.get('openProjectConfig')) === 1
      this.needConfirmProjectNo = Number(this.context.config.get('needConfirmProjectNo')) === 1
      this.isProjectLinkedCustomer = Number(this.context.config.get('isProjectLinkedCustomer')) === 1 // 项目是否和委托单位关联
      this.isZY = String(this.context.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatus = 0
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.cargoSourceEnabled = this.isEdit
      this.overseaAgentDataProviderChange = false
      this.salesList = null
      this.salesPrompt = ''
      this.overseaAgentUsersList = null
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }
      this.pm.init()
      /* ****************************** end ****************************** */
      this.form = row
      this.pm.changeJob()
      this.pm.fillView()
      this.loadCustomerIdContractInfo()
      this.mergeSurchargeTerms()
      JobUtils.setSailingDay(this.form)
      if (this.isEdit) {
        this.setCustomJobTypeFunc()
      }
      // fba
      if (this.isEdit && this.form.fba) {
        await getJobAvailableChannels({ tenantId: this.tenantId }).then(res => {
          this.channel4JobSelect = res.data.filter(e => e.shippingType === 'RE')
        })
      }
      if (this.form.fba) {
        if (this.form.uuid || this.form.fbaJob) {
          this.fbaJob = this.form.fbaJob
        } else {
          this.fbaJob = new FbaJob().fillDefaultValue().getData()
          this.fbaJob.bubbleCountingRatio = 6000.0
        }
        this.bubbleCountingRatio = this.fbaJob.bubbleCountingRatio
        this.chargingMethod = this.fbaJob.chargingMethod
        this.destinationDistribution = this.fbaJob.destinationDistribution
        this.bubbleCountingRatio = this.fbaJob.bubbleCountingRatio
        this.bubbleSplittingRatio = this.fbaJob.bubbleSplittingRatio
        await this.changeChannelName(this.form.serviceChannel)
        this.serviceChannel = this.form.serviceChannel
        this.getCargoType()
        if (this.action === 'add') {
          this.form.containerLoadType = 'LCL'
        }
        // 初始化增值服务
        let valueAddedServices = []
        if (this.fbaJob.valueAddedServices && this.fbaJob.valueAddedServices.split(',').length > 0) {
          valueAddedServices = this.fbaJob.valueAddedServices.split(',')
        }
        const res = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_ValueAddedService)
        for (const item of res) {
          if (item.fbaRailway) {
            switch (Number(item.serviceType)) {
              case 0:
                this.localAddedService.push(item)
                if (valueAddedServices.indexOf(item.code) >= 0) {
                  this.form[item.code] = true
                  this.selectedLocalAddedService.push(item.code)
                }
                break
              case 1:
                this.podAddedService.push(item)
                if (valueAddedServices.indexOf(item.code) >= 0) {
                  this.form[item.code] = true
                  this.selectedPodAddedService.push(item.code)
                }
                break
            }
          }
        }
      } else {
        this.cargoType4JobSelect = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CargoType).filter(p => p.sea)
      }
      if (!this.isEdit && this.form.poNo && this.needConfirmProjectNo && !this.openProjectConfig) {
        this.poNoRed = await checkPoNoIsExist(this.form.poNo, this.form.uuid).then(res => res.data) > 0
      }
      JobUtils.loadCompanyCargoSales(this, this.form, this.pm.isSpecifiedSalesBusiness)
      if (this.$store.getters.enableFrontEndPlugin) {
        this.setUserDefinedRoleDataUI()
      }
    },
    bubbleCountingChange() {
      if (this.fbaJob.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.BubbleCountingRatio')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.fbaJob.bubbleCountingRatio = this.bubbleCountingRatio
      } else {
        if (this.fbaJob.bubbleCountingRatio > 9999) {
          this.fbaJob.bubbleCountingRatio = 9999
          this.bubbleCountingRatio = 9999
        } else {
          this.bubbleCountingRatio = this.fbaJob.bubbleCountingRatio
        }
      }
    },
    // 加载委托单位签约信息
    async loadCustomerIdContractInfo() {
      let company = this.context.companyList.find(p => p.cmpIdx === this.form.customerId)
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatus = 0
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.contactList = []
      this.stampPictureView.businessDocuments = []
      if (!company || !company.cmpIdx) {
        return
      }
      company = new Company(company)
      await this.loadCustomerDetial(company)
      this.getContractStatus(company) // 获取合约状态
      this.contactList = await Company.loadContact(company.uuid)
    },
    async loadCustomerDetial(company) {
      let customer = await Company.loadCustomer(company.uuid).then(data => data.length > 0 ? data[0] : null)
      this.advancePaymentLabel = company && company.ifAdvancePayment ? this.$t('Partners.IfAdvancePayment') : ''
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      if (customer) {
        customer = new Customer(customer)
        const customerType = await customer.getCustomerType()
        if (customerType) {
          this.customerLevel.level = customerType.typeId
          this.customerLevel.customerName = customerType.chineseName
        }
      }
    },
    // 获取合约状态
    getContractStatus(company) {
      this.stampPictureView.businessDocuments = []
      if (!company) return
      Company.loadAgreementClientContract(company.uuid).then(async contracts => {
        if (contracts && contracts.length > 0) {
          const now = moment()
          const businessIds = []
          for (const item of contracts) {
            // 过滤出当前合作伙伴所有未到期的合同
            if (dateCompareYMD(item.endDate, now) >= 0) {
              businessIds.push(item.uuid)
            }
          }
          if (businessIds.length > 0) {
            findBusinessDocument({ businessIds: businessIds }).then(res => {
              const docs = res.data
              if (docs && docs.length > 0) {
                const useDocs = []
                for (const doc of docs) {
                  if (!doc.fileCategory || doc.fileCategory !== 'STAMP') continue
                  if (!doc.fileType || !SystemConstants.IMAGES.includes(doc.fileType.toUpperCase())) continue
                  useDocs.push(doc)
                }
                this.stampPictureView.businessDocuments = useDocs
              }
            })
          }

          company.contractStatus = businessIds.length > 0 ? 2 : 1
          // if (res.data.find(p => dateCompare(p.endDate, now) > 0)) {
          //   company.contractStatus = 2
          // } else {
          //   company.contractStatus = 1
          // }
        } else {
          company.contractStatus = 0
        }
        const contractState = this.contractStatuses[company.contractStatus]
        this.contractStatus = company.contractStatus
        this.contractStatusLabel = contractState ? contractState.label : ''
        this.customerTip = await JobUtils.getCustomerCreditTip(company.cmpIdx, CreditInfoUtil.getJobData(this.form))
      })
    },
    customJobTypeFilter(item, inputVal) {
      return (item.type === this.form.lob) && item.active && item.grade === 0
    },
    mergeSurchargeTerms() {
      let text = ''
      for (const item of this.form.surchargeTerms) {
        if (item.deleted) {
          continue
        }
        if (text) {
          text += '\n'
        }
        const chargeItemName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId, 'zhName')
        text += `${chargeItemName}：${item.terms}`
      }
      this.txtSurchargeTerms = text
    },
    warehouseNameChangeHandler(warehouseName) {
      if (this.form.warehouseInfo.length === 0) {
        return
      }
      const warehouseInfo = this.form.warehouseInfo[0]
      warehouseInfo.warehouseName = warehouseName
      const w = this.warehouseNameList.find(item => item.warehouseName === warehouseName)
      if (w) {
        warehouseInfo.warehouseContactTel = w.warehouseContactTel
        warehouseInfo.warehouseContact = w.warehouseContact
        warehouseInfo.warehouseAddress = w.warehouseAddress
        warehouseInfo.mapFile = w.mapFile
        if (w.remarks) {
          warehouseInfo.remarks = w.remarks
        }
      } else {
        warehouseInfo.warehouseContactTel = ''
        warehouseInfo.warehouseContact = ''
        warehouseInfo.warehouseAddress = ''
        warehouseInfo.mapFile = ''
        warehouseInfo.remarks = ''
      }
      this.pm.addWarehouseToModifiedSet(warehouseInfo)
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      // const reqKeys = this.getRequestSelectedKeys()
      // params.REQUEST_UUID = (!reqKeys || reqKeys.length === 0 ? '' : reqKeys)
      PrintTemplateUtil.buildPrintDataByBookingRe(this.form, params)
      params.category = 'BOOKING_RE'
      params.ctx = new RailwayExportJob(this.form)
      return params
    },
    // 打印回调
    printedCallback(event) {
      this.$logger.log(event)
      const template = event.template
      const documentType = event.documentType
      if (template && documentType) {
        const objParams = { jobUuid: this.form.uuid, docKeys: documentType.uuid }
        this.$logger.log(objParams)
        updateTrackingForDocumentType(objParams)
      }
    },
    // 客户特殊要求
    getRequestSelectedKeys() {
      return this.$refs['selectedSpecialRequest'].getRequestSelectedKeys() || []
    },
    // 判断选中的委托单位，是否禁止到期合同创建业务，CARGO-7885
    async customerIdChange2ContractHandler(company) {
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatus = 0
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.contactList = []
      this.cargoSalesList = null
      this.form.customerContact = ''
      this.form.editCftMode = false
      this.stampPictureView.businessDocuments = []
      if (this.form.customerId && parseInt(this.form.customerId) > 0) {
        this.form.preCustomerId = this.form.customerId
      }
      if (!company.cmpIdx) {
        this.form.customerId = 0
        return
      }
      const validateRes = await validateReleaseNumberCustomer({
        companyId: company.cmpIdx,
        officeId: this.$store.getters.currentOfficeId
      })
      if (validateRes && validateRes.data && validateRes.data.allowed === false) {
        if (validateRes.data.message) {
          this.$message.warning(validateRes.data.message)
        }
        this.form.customerId = 0
        console.log('[ReleaseNumber] Railway tabBookingFCL clear', !!this.$refs.customerSelect)
        if (this.$refs.customerSelect && this.$refs.customerSelect.clear) {
          this.$refs.customerSelect.clear()
        }
        return
      }
      // 中邮委托单位是否黑名单
      const blacklist = await JobUtils.checkBlacklistByCustomerId(company.cmpIdx)
      if (blacklist) {
        // return
      }
      // 欧坚委托单位是否风险客户
      await JobUtils.checkRiskyCustomersByByCustomerId(company.cmpIdx, StrUtils.isEmpty(this.form.uuid))
      // 这个验证必须在 this.form.customerId = company.cmpIdx 赋值之前，否则此验证无意义
      SEUtils.refreshChargeAccountId(this.form, 'customerId', this.$t('SeaExport.ConsignationCompany'), this.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
      this.form.customerId = company.cmpIdx

      company = new Company(company)
      const isForbid = await Contract.isContractExpiredForbidCreateJob(company.cmpIdx)
      if (isForbid) {
        this.form.customerId = 0
        this.$message.info('该委托单位合同到期，不能再创建业务')
        return
      }

      // 合同限制校验：检查是否启用合同限制且可放号天数<=0
      const contractLimitEnabled = company.contractLimitEnabled
      const availableDays = company.availableReleaseDays

      // contractLimitEnabled 可能是 '1' 或 1
      if (contractLimitEnabled === '1' || contractLimitEnabled === 1) {
        // availableReleaseDays 可能是数字或字符串，需要转换
        const daysNum = parseInt(availableDays) || 0
        if (daysNum <= 0) {
          const companyName = company.chineseName || company.englishName || '该委托单位'
          this.$message.warning(`${companyName} 未上传合同/合同失效，无法放号，请联系客户管理人员`)
          this.form.customerId = 0
          if (this.$refs.customerSelect && this.$refs.customerSelect.clear) {
            this.$refs.customerSelect.clear()
          }
          return
        }
      }

      if (company.incoTerm) {
        const incoTerm = company.incoTerm.split(',')
        if (incoTerm.length > 0) {
          this.form.incoTerm = incoTerm[0]
        }
      }
      await this.loadCustomerDetial(company)
      this.getContractStatus(company) // 获取合约状态
      this.contactList = await Company.loadContact(company.uuid)
      const contact = this.getDefaultContact(this.contactList)
      this.form.customerContact = contact ? contact.contactPerson : ''
      this.pm.onCustomerContactLoad()
      this.pm.onCustomerDetailLoad()
      this.pm.loadCustomerPortDestinationAgents()
      this.pm.loadCompanyUser() // 销售
      if (this.fbaJob.serviceChannel && this.form.chargeWeight && this.form.chargeWeight > 0) {
        await this.$confirm(this.$t('FbaJob.changeCustomer'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          // 刷新费用
          this.refreshCharge()
        }).catch(() => {
        })
      }
      if (company.mustInputScn) {
        this.form.editCftMode = true
      }
      this.pm.checkNewJobCreditInfo()
      this.showWarningImageB = false
      if (this.creditOpen) {
        this.pm.checkCreditByCompany(company.cmpIdx, 1)
      }
      JobUtils.loadCompanyCargoSales(this, this.form, this.pm.isSpecifiedSalesBusiness, true)
    },
    addedServiceChangeHandler() {
      this.fbaJob.valueAddedServices = this.selectedLocalAddedService.concat(this.selectedPodAddedService).join(',')
    },
    singleAddedServiceChangeHandler(val, item) {
      this.form[item.code] = val
      // 需特殊处理的增值服务，如新增页签
      // 报关
      if (item.code === 'customs') {
        this.form.customsBroker = val ? this.form.customsBroker : 0
      }
    },
    getCargoType() {
      this.cargoType4JobSelect = []
      const res = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CargoType)
      let acceptableGoods = []
      if (this.fbaQuotation) {
        acceptableGoods = this.fbaQuotation.acceptableGoods.split(',')
      }
      for (const item of res) {
        if (this.fbaQuotation) {
          const valid = acceptableGoods && acceptableGoods.length > 0 && acceptableGoods.indexOf(item.code) > -1
          if (!valid) {
            continue
          }
        }
        if (item.fbaRailway) {
          this.cargoType4JobSelect.push(item)
        }
      }
      if (this.form.cargoType && this.cargoType4JobSelect.map(item => item.code).indexOf(this.form.cargoType) === -1) {
        this.form.cargoType = ''
      }
    },
    // 更改服务渠道
    async changeServiceChannel(channel) {
      if (!channel) {
        this.serviceChannel = null
        this.fbaChannel = null
        this.fbaQuotation = null
        this.form.fbaChannel = this.fbaChannel
        this.form.fbaQuotation = this.fbaQuotation
        return
      }
      let update = false
      let refreshCharge = false
      if (typeof this.form.customerId === 'number' && this.form.customerId > 0) {
        await this.changeChannelName(channel)
        const containCustomer = await this.checkChangeChannel()
        if (containCustomer) {
          if (typeof this.fbaJob.warehouseCode === 'string' && this.fbaJob.warehouseCode) {
            // 判断区中是否包含该目的地
            if (this.checkWarehouseCode()) {
              // 判断计费重量是否有值
              if (this.form.customerId && this.form.chargeWeight && this.form.chargeWeight > 0) {
                await this.$confirm(this.$t('FbaJob.refreshCharge'), this.$t('Message.Tips'), {
                  confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                  cancelButtonText: this.$t('CargoMsg.Cargo_No'),
                  type: 'warning'
                }).then(() => {
                  refreshCharge = true
                }).catch(() => {
                })
              }
            } else {
              await this.$alert(StrUtils.substitute(this.$t('FbaJob.cargoTypeNotExist'), this.form.warehouseCode), this.$t('Message.Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                type: 'warning'
              })
              this.form.warehouseCode = ''
            }
          }
          update = true
        } else {
          await this.$confirm(this.$t('FbaJob.changeChannel'), this.$t('Message.Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
            cancelButtonText: this.$t('CargoMsg.Cargo_No'),
            type: 'warning'
          }).then(async() => {
            update = true
            if (!this.checkWarehouseCode()) {
              this.form.warehouseCode = ''
            }
          }).catch(async() => {
            this.fbaJob.serviceChannel = this.serviceChannel
            await this.changeChannelName(this.serviceChannel)
            return Promise.reject(this.$t('Message.EditCancelled'))
          })
        }
      } else {
        if (typeof this.form.warehouseCode === 'string' && this.form.warehouseCode) {
          // 判断区中是否包含该目的地
          if (!this.checkWarehouseCode()) {
            await this.$alert(StrUtils.substitute(this.$t('FbaJob.cargoTypeNotExist'), this.form.warehouseCode), this.$t('Message.Tips'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
              type: 'warning'
            })
            this.form.warehouseCode = ''
          }
        }
        update = true
      }
      if (update) {
        this.serviceChannel = channel
        await this.changeChannelName(channel)
        this.fbaJob.serviceChannel = channel
        await this.checkCargoType()
        if (this.fbaChannel) {
          this.syncJobInfoByChannel()
        }
        this.getCargoType()
      }
      if (refreshCharge) {
        // 刷新费用
        await this.refreshCharge()
      }
    },
    // 更新渠道同步业务字段
    syncJobInfoByChannel() {
      this.fbaJob.chargingMethod = this.fbaChannel.chargingMethod + ''
      this.fbaJob.destinationDistribution = this.fbaChannel.destinationDistribution + ''
      this.fbaJob.bubbleCountingRatio = this.fbaChannel.bubbleCountingRatio
      this.fbaJob.bubbleSplittingRatio = this.fbaChannel.bubbleSplittingRatio
      this.chargingMethod = this.fbaJob.chargingMethod
      this.destinationDistribution = this.fbaJob.destinationDistribution
      this.bubbleCountingRatio = this.fbaJob.bubbleCountingRatio
      this.bubbleSplittingRatio = this.fbaJob.bubbleSplittingRatio
    },
    // 更改目的地
    async changeWarehouseCode() {
      if (this.form.customerId && this.fbaJob.serviceChannel && this.form.chargeWeight && this.form.chargeWeight > 0) {
        await this.$confirm(this.$t('FbaJob.changeWarehouseCode'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          // 刷新费用
          this.refreshCharge()
        }).catch(() => {
        })
      }
    },
    // 刷新费用
    async refreshCharge() {
      let authorizationValue = null
      let customers = []
      // 查找对应运价级别的客户
      for (const e of this.fbaQuotation.customerPriceList) {
        const item = { anyInteger: e.quotationObject }
        await searchCustomerPrice(item).then(res => {
          const result = res.data || []
          customers = customers.concat(result)
        })
      }
      if (customers && customers.length > 0) {
        for (const customer of customers) {
          if (Number(this.form.customerId) === Number(customer.CMP_IDX)) {
            authorizationValue = customer.AUTHORIZATION_VALUE
            break
          }
        }
      }
      if (authorizationValue) {
        const params = {
          fbaChannel: this.fbaChannel,
          fbaQuotation: this.fbaQuotation,
          quantity: this.form.quantityActual,
          weight: this.form.weightActual,
          cubage: this.form.cubageActual,
          volumetricWeight: this.form.volumetricWeight,
          chargeWeight: Number(this.form.chargeWeight),
          warehouseCode: this.fbaJob.warehouseCode,
          authorizationValue: authorizationValue
        }
        const fbaChargeInfo = FbaQuotationUtil.getFbaChargeInfo(params)
        if (fbaChargeInfo) {
          fbaChargeInfo.authorizationValue = authorizationValue
        }
        const fbaAdditionalChargeInfo = FbaQuotationUtil.getFbaAdditionalChargeInfo(params)
        if (fbaAdditionalChargeInfo) {
          fbaAdditionalChargeInfo.authorizationValue = authorizationValue
        }
        if (this.form.charges && this.form.charges.length > 0) {
          let matchCharge = false
          const chargeList = []
          let matchAdditionalCharge = false
          const additionalChargeList = []
          for (const item of this.form.charges) {
            if (fbaChargeInfo) {
              const chargeItemId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'zhName', '运费', 'itemId')
              if (item.chargeItemId === chargeItemId) {
                matchCharge = true
                chargeList.push(item)
              }
            }
            if (fbaAdditionalChargeInfo) {
              const chargeItemList = getCacheListByKey(basicCacheKeys.basic_data_ChargeItem)
              const matchList = chargeItemList.filter(p => (item.chargeItemId === p.itemId) && p.surcharge)
              if (matchList && matchList.length > 0) {
                matchAdditionalCharge = true
                additionalChargeList.push(item)
              }
            }
          }
          if (matchCharge) {
            this.updateCharge(fbaChargeInfo, chargeList)
          } else {
            await this.createCharge(fbaChargeInfo)
          }
          if (matchAdditionalCharge) {
            this.updateCharge(fbaAdditionalChargeInfo, additionalChargeList, true)
          } else {
            await this.createCharge(fbaAdditionalChargeInfo, true)
          }
        } else {
          if (fbaChargeInfo) {
            await this.createCharge(fbaChargeInfo)
          }
          if (fbaAdditionalChargeInfo) {
            await this.createCharge(fbaAdditionalChargeInfo, true)
          }
        }
      }
    },
    // 更新费用
    updateCharge(fbaChargeInfo, chargeList, additional = false) {
      for (const item of chargeList) {
        if (!item.confirmBillUuid &&
            !item.invoiceUuid && !item.billingUuid && !item.billingPaymentUuid &&
            !item.verifiedAmount && !item.paidOff && item.chargeState === 0 &&
            ((item.receivable && this.form.receivableChargeLockedStatus === 0) || (!item.receivable && this.form.payableChargeLockedStatus === 0))) {
          if (fbaChargeInfo) {
            item.chargeItemId = fbaChargeInfo.chargeItemId
            item.currency = fbaChargeInfo.currency
            item.quantity = fbaChargeInfo.quantity
            item.unitRate = fbaChargeInfo.unitRate
            item.amount = fbaChargeInfo.amount
            item.excludingTaxAmount = fbaChargeInfo.excludingTaxAmount
            item.measure = fbaChargeInfo.measure
            item.accountId = this.form.customerId
            ChargeUtils.calculateTax(item, item.quantity * item.unitRate, item.taxRate, true)
            ChargeUtils.getChargeisOverseaNotControlledByConfig(item)
            const localCurrency = RateUtil.localCurrencyByOffice()
            let remarks = ''
            if (additional) {
              remarks = '服务渠道：' + this.fbaJob.serviceChannel + '\n' +
                  '费用类型：' + fbaChargeInfo.calcMethodStr + '\n' +
                  '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
                  '折合' + localCurrency + '：' + item.excludingTaxAmount
            } else {
              remarks = '服务渠道：' + this.fbaJob.serviceChannel + '\n' +
                  '运价级别：' + ColumnUtils.QuotationObjectLabelFunc(Number(fbaChargeInfo.authorizationValue)) + '\n' +
                  '计费重量：' + this.form.chargeWeight + '\n' +
                  '计算方式：' + fbaChargeInfo.calcMethodStr + '\n' +
                  '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
                  '折合' + localCurrency + '：' + item.excludingTaxAmount
            }
            item.remarks = remarks
          }
        }
      }
      if (this.form.api) {
        this.form.api.refreshCells({ force: true })
      }
    },
    // 新增费用
    async createCharge(fbaChargeInfo, additional = false) {
      if (fbaChargeInfo) {
        const charge = new Charge().fillDefaultValue().getData()
        charge.chargeItemId = fbaChargeInfo.chargeItemId
        charge.currency = fbaChargeInfo.currency
        charge.quantity = fbaChargeInfo.quantity
        charge.unitRate = fbaChargeInfo.unitRate
        charge.amount = fbaChargeInfo.amount
        charge.excludingTaxAmount = fbaChargeInfo.excludingTaxAmount
        charge.measure = fbaChargeInfo.measure
        charge.accountId = this.form.customerId
        await BookingUtil.getNewCharge(charge, this.form, true)
        ChargeUtils.getChargeisOverseaNotControlledByConfig(charge)
        const localCurrency = RateUtil.localCurrencyByOffice()
        let remarks = ''
        if (additional) {
          remarks = this.$t('RailwayExport.ServiceChannel2') + this.fbaJob.serviceChannel + '\n' +
              this.$t('RailwayExport.CostType') + fbaChargeInfo.calcMethodStr + '\n' +
              this.$t('RailwayExport.EstimatedAmount') + fbaChargeInfo.estimatedAmountStr + '\n' +
              this.$t('RailwayExport.EquivalentTo') + localCurrency + '：' + charge.excludingTaxAmount
        } else {
          remarks = this.$t('RailwayExport.ServiceChannel2') + this.fbaJob.serviceChannel + '\n' +
              this.$t('RailwayExport.FareLevel') + ColumnUtils.QuotationObjectLabelFunc(Number(fbaChargeInfo.authorizationValue)) + '\n' +
              this.$t('RailwayExport.BillingWeight') + this.form.chargeWeight + '\n' +
              this.$t('RailwayExport.CalculationMethod') + fbaChargeInfo.calcMethodStr + '\n' +
              this.$t('RailwayExport.EstimatedAmount') + fbaChargeInfo.estimatedAmountStr + '\n' +
              this.$t('RailwayExport.EquivalentTo') + localCurrency + '：' + charge.excludingTaxAmount
        }
        charge.remarks = remarks
        this.context.reloadCharge = true
      }
    },
    // 判断区中是否包含该目的地
    checkWarehouseCode() {
      let result = false
      if (this.fbaQuotation) {
        const partitionSettingList = this.fbaQuotation.partitionSettingList
        let warehouseCode = []
        for (const item of partitionSettingList) {
          const pod = item.pod
          if (pod && pod.split(',').length > 0) {
            warehouseCode = warehouseCode.concat(pod.split(','))
          }
        }
        result = warehouseCode.indexOf(this.fbaJob.warehouseCode) > -1
      }
      return result
    },
    // 判断可接货物是否包含当前货物类型
    async checkCargoType() {
      const acceptableGoodsStr = this.fbaQuotation.acceptableGoods
      let acceptableGoods = []
      if (acceptableGoodsStr && acceptableGoodsStr.split(',').length > 0) {
        acceptableGoods = acceptableGoodsStr.split(',')
      }
      if (acceptableGoods.indexOf(this.form.cargoType) === -1 && this.form.cargoType) {
        const acceptableGoodsTag = ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_CargoType, 'code', this.form.cargoType, 'chineseName')
        await this.$alert(StrUtils.substitute(this.$t('FbaJob.cargoTypeNotExist'), acceptableGoodsTag), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.form.cargoType = ''
      }
    },
    // 判断是否更新渠道
    async checkChangeChannel() {
      let customers = []
      let containCustomer = false
      // 查找对应运价级别的客户
      if (this.fbaQuotation) {
        for (const e of this.fbaQuotation.customerPriceList) {
          const item = { anyInteger: e.quotationObject }
          await searchCustomerPrice(item).then(res => {
            const result = res.data || []
            customers = customers.concat(result)
          })
        }
        if (customers && customers.length > 0) {
          for (const customer of customers) {
            if (Number(this.form.customerId) === Number(customer.CMP_IDX)) {
              containCustomer = true
              break
            }
          }
        }
      }
      return containCustomer
    },
    async changeChannelName(channelName) {
      const channel = this.channel4JobSelect.find(e => channelName === e.channelName)
      if (channel) {
        this.fbaChannel = channel
        this.fbaQuotation = new FbaQuotation().fillDefaultValue().getData()
        this.fbaQuotation.uuid = channel.quotationUuid
        const jobModel = new FbaQuotation(this.fbaQuotation)
        await jobModel.loadFbaQuotationRelated({
          quotation: true,
          label: true,
          partitionSetting: true,
          setupSetting: true,
          charge: true,
          customerPrice: true
        })
        this.form.fbaChannel = this.fbaChannel
        this.form.fbaQuotation = this.fbaQuotation
      } else {
        this.fbaChannel = null
        this.fbaQuotation = null
        this.form.fbaChannel = this.fbaChannel
        this.form.fbaQuotation = this.fbaQuotation
      }
    },
    bubbleSplittingRatioChange() {
      if (this.fbaJob.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.BubbleSplittingRatio')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.fbaJob.bubbleSplittingRatio = this.bubbleSplittingRatio
      } else {
        if (this.fbaJob.bubbleSplittingRatio > 100) {
          this.fbaJob.bubbleSplittingRatio = 100
          this.bubbleSplittingRatio = 100
        } else {
          this.bubbleSplittingRatio = this.fbaJob.bubbleSplittingRatio
        }
      }
    },
    quantityActualChange() {
      if (this.isFba) {
        const refreshCharge = this.calcActVolumetricAndChargeWeight()
        if (refreshCharge) {
          this.changeChargeWeight()
        }
      }
    },
    calcEstVolumetricAndChargeWeight(volumetricWeight) {
      if (!this.isFba) {
        return
      }
      const cubage = this.form.cubageContract * 1000000
      // 材积
      if (volumetricWeight && volumetricWeight > 0) {
        this.form.volumetricWeightContract = volumetricWeight
      } else {
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.fbaJob.chargingMethod) === 0) {
            this.form.volumetricWeightContract = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            this.form.volumetricWeightContract = (this.form.weightContract / 1000).toFixed(3)
          }
        }
      }
      // 计费重量
      const params = {
        fbaQuotation: this.fbaQuotation,
        chargingMethod: this.fbaJob.chargingMethod,
        quantity: this.form.quantityContract,
        weight: this.form.weightContract,
        cubage: this.form.cubageContract,
        volumetricWeight: this.form.volumetricWeightContract
      }
      const chargeWeight = FbaQuotationUtil.calChargeWeight(params)
      if (this.form.quantityContract > 0 && this.form.weightContract > 0 && this.form.cubageContract > 0 && this.form.volumetricWeightContract > 0) {
        this.form.chargeWeightContract = Number(chargeWeight).toFixed(3)
      }
      this.form.volumetricWeightContract = Number(this.form.volumetricWeightContract).toFixed(3)
      this.form.chargeWeightContract = Number(this.form.chargeWeightContract).toFixed(3)
    },
    calcActVolumetricAndChargeWeight(volumetricWeight) {
      const cubage = this.form.cubageActual * 1000000
      // 材积
      if (volumetricWeight && volumetricWeight > 0) {
        this.form.volumetricWeight = volumetricWeight
      } else {
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.fbaJob.chargingMethod) === 0) {
            this.form.volumetricWeight = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            this.form.volumetricWeight = (this.form.weightActual / 1000).toFixed(3)
          }
        }
      }
      // 计费重量
      const params = {
        fbaQuotation: this.fbaQuotation,
        chargingMethod: this.fbaJob.chargingMethod,
        quantity: this.form.quantityActual,
        weight: this.form.weightActual,
        cubage: this.form.cubageActual,
        volumetricWeight: this.form.volumetricWeight
      }
      const chargeWeight = FbaQuotationUtil.calChargeWeight(params)
      const refreshCharge = Number(chargeWeight) !== Number(this.form.chargeWeight)
      if (this.form.quantityActual > 0 && this.form.weightActual > 0 && this.form.cubageActual > 0 && this.form.volumetricWeight > 0) {
        this.form.chargeWeight = Number(chargeWeight).toFixed(3)
      }
      this.form.volumetricWeight = Number(this.form.volumetricWeight).toFixed(3)
      this.form.chargeWeight = Number(this.form.chargeWeight).toFixed(3)
      return refreshCharge
    },
    async changeVolumetricWeight() {
      if (this.isFba) {
        const refreshCharge = this.calcActVolumetricAndChargeWeight(this.form.volumetricWeight)
        if (refreshCharge) {
          await this.changeChargeWeight()
        }
      }
    },
    async changeChargeWeight() {
      if (this.isFba) {
        if (this.form.customerId && this.fbaJob.serviceChannel && this.form.chargeWeight && this.form.chargeWeight > 0) {
          await this.$confirm(this.$t('FbaJob.changeChargeWeight'), this.$t('Message.Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
            cancelButtonText: this.$t('CargoMsg.Cargo_No'),
            type: 'warning'
          }).then(() => {
            // 刷新费用
            this.refreshCharge()
          }).catch(() => {
          })
        }
      }
    },
    // 目的地配送方式改变
    destinationDistributionChange() {
      if (this.fbaJob.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.DestinationDistribution')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.fbaJob.destinationDistribution = this.destinationDistribution
      } else {
        this.destinationDistribution = this.fbaJob.destinationDistribution
        this.syncConsigneeInfo()
      }
    },
    // 改变计费方式
    chargingMethodChange() {
      if (this.fbaJob.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.ChargingMethod')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.fbaJob.chargingMethod = this.chargingMethod
      } else {
        this.chargingMethod = this.fbaJob.chargingMethod
      }
    },
    getDefaultContact(contactList) {
      if (!contactList || contactList.length <= 0) return ''
      const c = contactList.find(item => item.defaultContact)
      return c || contactList[0]
    },
    showContactDialog() {
      if (!this.form.customerContact) {
        return
      }
      for (const item of this.contactList) {
        if (item.contactPerson === this.form.customerContact) {
          this.contactDialog.data = item
          this.contactDialog.visible = true
          return
        }
      }
      this.contactDialog.data = {}
      this.contactDialog.visible = true
    },
    async etdChange(value) {
      this.form.etd = value
      this.form.sailingDay = JobUtils.dateChange(this.form.etd)
      this.pm.ETDChange()
      if (this.form.lob === 'RE') {
        await ChargeUtils.updateETDFee(this.form, this.form.etd, this.context, true)
      }
    },
    async etaChange(value) {
      this.form.eta = value
      this.form.etaSailingDay = JobUtils.dateChange(this.form.eta)
      if (this.form.lob === 'RI') {
        await ChargeUtils.updateETDFee(this.form, this.form.eta, this.context, true)
      }
    },
    async atdChange(value) {
      this.form.atd = value
      this.form.atdSailingDay = JobUtils.dateChange(this.form.atd)
    },
    async ataChange(value) {
      this.form.ata = value
      this.form.ataSailingDay = JobUtils.dateChange(this.form.ata)
    },
    async weightContractChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.pm.refreshWeightCharge(this.form, this.form.weightContract)
      }
      this.pm.jobContractQwcChange(2)
    },
    async weightActualChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.pm.refreshWeightCharge(this.form, this.form.weightActual)
      }
      await SEUtils.changeQWCRule(null, async() => {
        if (this.form.weightContract !== this.form.weightActual) {
          this.form.weightContract = this.form.weightActual
          if (ChargeUtils.getChargeWeightValueType(true) === 1) {
            await this.pm.refreshWeightCharge(this.form, this.form.weightContract)
          }
        }
      })
      if (!this.form.fba) {
        this.pm.calculateChargeWeight()
      }
      this.pm.refContainerUsageQwc(2)
      if (this.isFba) {
        const refreshCharge = this.calcActVolumetricAndChargeWeight()
        if (refreshCharge) {
          this.changeChargeWeight()
        }
      }
    },
    async cubageContractChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.pm.refreshCubageCharge(this.form, this.form.cubageContract)
      }
      this.pm.jobContractQwcChange(3)
    },
    async cubageActualChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.pm.refreshCubageCharge(this.form, this.form.cubageActual)
      }
      await SEUtils.changeQWCRule(null, async() => {
        if (this.form.cubageContract !== this.form.cubageActual) {
          this.form.cubageContract = this.form.cubageActual
          if (ChargeUtils.getChargeWeightValueType(true) === 1) {
            await this.pm.refreshCubageCharge(this.form, this.form.cubageContract)
          }
          this.form.chargeWeight = this.form.cubageActual
        }
      })
      if (!this.form.fba) {
        this.pm.calculateChargeWeight()
      }
      this.pm.refContainerUsageQwc(2, false)
      if (this.isFba) {
        const refreshCharge = this.calcActVolumetricAndChargeWeight()
        if (refreshCharge) {
          this.changeChargeWeight()
        }
      }
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.railwayExport && item.active
    },
    showHsCodeSearchDialog(title, successCallback) {
      this.hsCodeSearchDialog.title = title
      this.hsCodeSearchDialog.successCallback = successCallback
      this.hsCodeSearchDialog.visible = true
    },
    showAdvanceTextDialog(title, value, autoUppercase, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.autoUppercase = autoUppercase
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    async salesChange(data) {
      const form = this.form
      form.sales = data.value
      if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        form.salesOffice = data.defaultOfficeId
        form.salesDepartment = data.defaultDepId
        const office = await Office.getOfficeById(this.form.salesOffice)
        this.salesOfficeText = office.chineseName
      } else {
        const user = new User(data)
        const department = user.getDefaultDepartment('role', 'sales')
        const office = Office.getOfficeByUuid(department.officeUuid)
        form.salesOffice = office.officeId
        form.salesDepartment = department.departmentId
        this.salesOfficeText = office.chineseName
      }
    },
    handleSurchargeTerms(data) {
      const surchargeTerms = this.form.surchargeTerms
      surchargeTerms.splice(0, surchargeTerms.length)
      surchargeTerms.push(...data)
      this.mergeSurchargeTerms()
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.form['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.form['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.form['notifyLine7'] || '')
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    async getSubmitData() {
      this.form.masterJobNo = this.form.lclMaster ? this.form.lclMaster.jobNo : '' // // 主票新增小票的时候使用
      await this.validateForm()

      if (this.form.customerContact) {
        for (const item of this.contactList) {
          if (item.contactPerson === this.form.customerContact) {
            this.form.contactEmail = item.email
          }
        }
      }

      // fba业务
      const fbaJob = this.isFba ? { ...this.fbaJob } : null
      return {
        job: this.form,
        seaEQ: this.seaEqList,
        delseaEQUuids: this.form.delseaEQUuids,
        cargoBulkDetailList: this.cargoBulkDetailList,
        containers: this.form.containers,
        delContainerUuids: this.form.delContainerUuids, // 删除的箱子uuid
        delContainerUsageUuids: this.form.delContainerUsageUuids, // 删除的装箱uuid
        surchargeTerms: this.form.surchargeTerms,
        fbaJob // fba业务
      }
    },
    async validateForm() {
      const form = this.form
      if (form.customerId < 1) {
        throw new TabError(this.$t('Message.ConsignationCompanyCannotBeNull'), 'tabBookingFCL')
      }
      await JobUtils.checkCustomerBranchScope(form, 'tabBookingFCL')
      await SecurityUtil.companyisActive(this.$t('SeaExport.Customer'), form.customerId, 'tabBookingFCL')
      if (!form.containerLoadType) {
        throw new TabError(this.$t('RailwayExport.TheTypeCannotBeEmpty'), 'tabBookingFCL')
      }
      if (!form.transportType) {
        throw new TabError(this.$t('RailwayExport.TransportTypeCannotBeEmpty'), 'tabBookingFCL')
      }
      if (!form.fullHalf) {
        throw new TabError(this.$t('RailwayExport.FullJourneyCannotBeEmpty'), 'tabBookingFCL')
      }
      if (!form.transportLine) {
        throw new TabError(this.$t('RailwayExport.ShippingRouteCannotBeEmpty'), 'tabBookingFCL')
      }
      if (!form.etd) {
        throw new TabError(this.$t('RailwayExport.ETDNotNull'), 'tabBookingFCL')
      }
      if (form.etd && form.eta && form.eta < form.etd) {
        throw new TabError(this.$t('RailwayExport.DepartureBeLaterThanDate'), 'tabBookingFCL')
      }
      if (form.lob === 'RI' && !form.eta) {
        throw new TabError(this.$t('RailwayExport.ETANotNull'), 'tabBookingFCL')
      }
      if (!form.departureStation) {
        throw new TabError(this.$t('RailwayExport.DepartureStationCannotBeEmpty'), 'tabBookingFCL')
      }
      if (form.transfer && !form.transferStation) {
        throw new TabError(this.$t('RailwayExport.TransitStationCannotBeEmpty'), 'tabBookingFCL')
      }
      if (!form.transitStation) {
        throw new TabError(this.$t('RailwayExport.TransitStationCannotBeEmpty2'), 'tabBookingFCL')
      }
      if (!form.destinationStation) {
        throw new TabError(this.$t('RailwayExport.DestinationStationCannotBeEmpty'), 'tabBookingFCL')
      }
      if (form.cargoSource === 'SC' || parseInt(this.config.get('NorminationJobSaleType')) === 1) {
        if (!form.sales) {
          throw new TabError(this.$t('Message.SalesCannotBeNull'), 'tabBookingFCL')
        }
        if (!form.salesOffice) {
          throw new TabError(this.$t('Message.SalesBranchCompanyIsNullPleaseReSelectSales'), 'tabBookingFCL')
        }
        if (!form.salesDepartment) {
          throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabBookingFCL')
        }
      } else {
        if (form.sales && !form.salesDepartment) {
          throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabBookingFCL')
        }
      }
      if (form.cargoSource === 'NC' && !form.designationAgent) {
        throw new TabError(this.$t('Message.NominatedAgentCannotBeNull'), 'tabBookingFCL')
      }
      if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && form.designationAgent) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.NominatedAgent'), form.designationAgent, 'tabBookingFCL', 'englishName')
      }
      if (this.config.get('SERequirePONO') === '1' && !form.poNo) {
        throw new TabError(this.$t('Message.ItemNoCannotBeNull'), 'tabBookingFCL')
      }
      if (form.containerLoadType === 'FCL') {
        if (!this.seaEqList || this.seaEqList.length === 0) {
          throw new TabError(this.$t('Message.EQSizeCannotBeNull'), 'tabBookingFCL')
        }
      }
      // 校验 装箱和基本页签的件毛体是否一致
      const msg = ContainerUtil.validateContainerUsage(this.form)
      if (msg) {
        throw new TabError(msg, 'tabBookingFCL')
      }
      if (!form.paymentMethod) {
        throw new TabError(this.$t('RailwayExport.PaymentMethodCannotBeEmpty'), 'tabBookingFCL')
      }
      // 判断销售是否是本人(新增订舱预审)
      if (form.jobState === -1) {
        const bookingIsOpenSaleCheck = parseInt(this.config.get('BookingIsOpenSaleCheck')) === 0
        if (form.sales !== this.$store.getters.userInfo.userId && !bookingIsOpenSaleCheck) {
          throw new TabError(this.$t('Message.DearYouCanOnlySelectYourOwnCustomers'), 'tabBookingFCL')
        }
      }
      if (form.sales < 1) {
        // NorminationJobSaleType 为0时，揽货类型==“指定货”，业务销售允许为空
        if (!(form.cargoSource === 'NC' && parseInt(this.config.get('NorminationJobSaleType')) === 0)) {
          throw new TabError(this.$t('RailwayExport.SalesCannotBeEmpty'), 'tabBookingFCL')
        }
      }
      if (form.op < 1) {
        throw new TabError(this.$t('RailwayExport.OperationCannotBeEmpty'), 'tabBookingFCL')
      }
      if (!form.opDepartment) {
        throw new TabError(this.$t('SeaExport.OperationDepartmentCannotBeEmpty'), 'tabBookingFCL')
      }
      if ((form.containerLoadType === 'FCL' || form.containerLoadType === 'BB') && this.seaEqList && this.seaEqList.length > 0) {
        if (ContainerUtil.checkNoDuplationSeaEQ(form)) {
          throw new TabError(this.$t('SeaExport.RepeatBoxType'), 'tabBookingFCL')
        }
        if (ContainerUtil.checkSeaEqType(form)) {
          throw new TabError(this.$t('RailwayExport.AlreadyOtherBoxTypesTime'), 'tabBookingFCL')
        }
      }
      if (!SecurityUtil.customerIsOwn(form.customerId) && !form.uuid) {
        throw new TabError(this.$t('CargoMsg.Cargo_CustomerNotOwn'), 'tabBookingFCL')
      }
      // 海运头程 保存校验
      if (this.isFba && this.fbaJob) {
        if (!this.fbaJob.preWarehousingTime) {
          throw new TabError(this.$t('RailwayExport.EstimatedTimeCannotBeEmpty'), 'tabBookingFCL')
        }
        if (!this.fbaJob.warehouseCode) {
          throw new TabError(this.$t('RailwayExport.DestinationCannotBeEmpty'), 'tabBookingFCL')
        }
        if (!this.fbaJob.country) {
          throw new TabError(this.$t('RailwayExport.DestinationCountryCannotBeEmpty'), 'tabBookingFCL')
        }
        if (!this.fbaJob.zipCode) {
          throw new TabError(this.$t('RailwayExport.ZipCodeCannotBeEmpty'), 'tabBookingFCL')
        }
        if (!this.fbaJob.chargingMethod && this.fbaJob.chargingMethod !== 0) {
          throw new TabError(this.$t('FbaJob.ChargingMethod') + this.$t('RailwayExport.CannotBeEmpty'), 'tabBookingFCL')
        }
      }
      // 中邮定制字段 保存校验
      if (this.isZY && !form.saleProductCode) {
        throw new TabError(this.$t('Message.SaleProductCodeCannotBeNull'), 'tabBookingFCL')
      }
      if (this.isZY && !form.fullOrInside) {
        throw new TabError(this.$t('Message.FullOrInsideCannotBeNull'), 'tabBookingFCL')
      }
    },
    endTabHandler() {
      this.pm.fillModel()
    },
    executeTask() {
      // 保存客户发运信息
      this.addrPM.job = this.form
      this.addrPM.isPortFilter = true
      this.addrPM.shipperCodeField = ''
      this.addrPM.shipperField = 'shipperLine'
      this.addrPM.consigneeCodeField = ''
      this.addrPM.consigneeField = 'consigneeLine'
      this.addrPM.notifyCodeField = ''
      this.addrPM.notifyField = 'notifyLine'
      this.addrPM.viewFromBasic = true
      if (parseInt(this.config.get('syncMailingAddress')) === 1) {
        this.addrPM.saveCheck()
      }
    },
    fbaCodeSearchBtn() {
      if (!this.fbaJob || !this.fbaJob.customerId || Number(this.fbaJob.customerId) <= 0) {
        this.$message.warning(this.$t('RailwayExport.PleaseTheEntrustingUnitFirst'))
        return
      }
      this.fbaBillAddressDialog.visible = true
    },
    // fba收发通地址
    fbaCodeSearchCallback(data) {
      if (data.shipperInfo) {
        const curInfo = JobUtils.fbaHandleSft(data.shipperInfo, 'shipper')
        this.splitShipperLine(curInfo)
      }
      if (data.consigneeInfo) {
        const curInfo = JobUtils.fbaHandleSft(data.consigneeInfo, 'consignee')
        this.splitConsigneeLine(curInfo)
      }
      if (data.notifyInfo) {
        const curInfo = JobUtils.fbaHandleSft(data.notifyInfo, 'notify')
        this.splitNotifyLine(curInfo)
      }
    },
    // 客户属性过滤
    fbaCustomerIdFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customer && item.fba && item.active
    },
    async changeProject() {
      if (this.isProjectLinkedCustomer) {
        const company = await getPartnerByPoNo(this.form.poNo).then(res => {
          return res.data
        })
        if (company && this.form.customerId !== company.cmpIdx && company.active) {
          await this.customerIdChange2ContractHandler(company)
        }
      }
    },
    clearPoNo() {
      if (this.isProjectLinkedCustomer) {
        this.form.poNo = ''
        this.form.projectName = ''
      }
    },
    lobChangeHandler() {
      this.form.customJobType = ''
      this.form.secondaryCustomJobType = ''
      JobUtils.matchUserPortConfig(this, this.form)
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }))
    },
    departureStationChange(data) {
      this.form.departureStation = data.value
      JobUtils.matchUserPortConfig(this, this.form)
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }))
    },
    destinationStationChange(data) {
      this.form.destinationStation = data.value
      // CARGO-40145 修改目的站后同步带出目的国,如果修改后的值为null同步目的国也为null
      if (data.value) {
        const destinationStationCountryCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', data.value, 'countryCode')
        if (destinationStationCountryCode) {
          this.form.destinationCountry = destinationStationCountryCode
        } else {
          this.form.destinationCountry = ''
        }
      } else {
        this.form.destinationCountry = ''
      }
      JobUtils.matchUserPortConfig(this, this.form)
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }))
    },
    opOfficeChargeHandler() {
      JobUtils.opOfficeChange({ view: this, job: this.form, warehouseCallback: warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }) })
    },
    onCustomJobTypeChange() {
      JobUtils.matchUserPortConfig(this, this.form)
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }))
      this.form.secondaryCustomJobType = ''
      this.setSecondaryCustomJobTypeFunc()
    },
    setSecondaryCustomJobTypeFunc() {
      if (this.form.customJobType) {
        this.secondaryCustomJobTypeList = JobUtils.setSecondaryCustomJobTypeList(this.form.customJobType, this.form.lob)
      } else {
        this.secondaryCustomJobTypeList = []
      }
    },
    setCustomJobTypeFunc() {
      this.customJobTypeList = JobUtils.setCustomJobTypeList(this.form.lob, this.form.containerLoadType, this.form.fba)
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.form.opOffice = val
    },
    onCargoTypeChagne() {
      JobUtils.matchUserPortConfig(this, this.form)
    },
    // 合同规则相关字段切换时调用刷新【客户、指定货代理】信控信息
    contractRuleFieldChange(customerId, designationAgent) {
      this.pm.checkCredit()
      if (this.creditOpen) {
        // this.pm.checkCreditByCompany(customerId, 1)
        // this.pm.checkCreditByCompany(designationAgent, 2)
        this.pm.checkNewJobCreditInfo()
      }
    }
  }
}
</script>

<style scoped lang="scss" scoped>
#app .app-main-inner {

}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea{
    border: 1px solid red !important;
  }
}
</style>
